export const pt_strings = {
  'err.pattern.^0[1-9]\\d{6,14}$': 'O número deve começar com 0, seguido de um dígito entre 1 e 9 e depois de 6 a 14 dígitos.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': 'O campo "{fieldName}" só pode conter letras, acentos, espaços, apóstrofos, pontos e hífens.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': 'O campo "{fieldName}" só pode conter letras, números, acentos, espaços, hífens, pontos, apóstrofos e parênteses.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': 'O campo "{fieldName}" só pode conter letras, números, acentos, espaços, apóstrofos, pontos, parênteses e hífens.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': 'O campo "{fieldName}" só pode conter letras, números, acentos, espaços, apóstrofos, vírgulas, pontos, parênteses e hífens.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': 'O campo "{fieldName}" só pode conter letras, números, acentos, espaços, apóstrofos, pontos, parênteses e hífens.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': 'O campo "{fieldName}" só pode conter letras, números, acentos, espaços, apóstrofos, pontos, parênteses e hífens.',
  'tooltip.allNotes': 'Ver todas as notas',
  'tooltip.openDuplicate': 'Abrir o último pagamento duplicado',
  'payment.openDuplicate': 'Abrir a duplicata',
  'err.pattern.password': 'A palavra-passe deve conter pelo menos dois dos seguintes elementos: uma letra minúscula, uma letra maiúscula, um número ou um caractere especial.',
  'form.perm1.DYN.': 'Criar uma aplicação',
  'global.pay': 'Pagar',
  'smartTable.timeslot': 'Faixa horária',
  'smartTable.requestReason': 'Motivo do pedido',
  'smartTable.passportType': 'Tipo de passaporte',
  'refusalReason.desc.DYN.': '<p>Por favor, forneça uma breve descrição do motivo da recusa.</p>',
  'timezone.notice': 'Os agendamentos são feitos com base no fuso horário do local da consulta.',
  'timeslot.noBooking': 'Nenhum horário de reserva foi feito.',
  'timeslot.tooCloseToChange': 'Você não pode mais alterar esta consulta, pois ela está marcada para menos de {hours}h.',
  'session.inactive.title': 'Sessão inativa',
  'session.inactive': 'Sua sessão expirou por inatividade.',
  'reactivateSession': 'Reativar sessão',
  'global.changeTimeSlot': 'Alterar horário',
  'outUsage.AB': 'Esta aplicação está <b>fora do seu período de validade</b>. Por favor, direcione o solicitante para o quiosque ou ajude-o a reenviar seu pedido.',
  'outUsage.C': 'Esta aplicação está <b>fora do seu período de validade</b>. Por favor, feche este pedido, crie uma nova entrada para o solicitante e prossiga com a recusa.',
  'err.payment.notAvailable': 'Esta aplicação não está disponível.',
  'form.PlaceOfBirth': 'Local de nascimento',
  'borderPass': 'Passe fronteiriço',
  'urgent_pass': 'Passaporte urgente',
  'feedback': 'Feedback',
  'err.mustBeDifferentThan.errorValue': 'O campo "{fieldName}" deve ser diferente de {errorValue}.',
  'DYN.PASSPORT_WRONG': 'Passaporte incorreto',
  'err.max.errorValue': 'O campo "{fieldName}" deve ser inferior a {errorValue}.',
  'err.max': 'O campo "{fieldName}" deve ser inferior ao valor máximo permitido.',
  'err.min.errorValue': 'O campo "{fieldName}" deve ser superior a {errorValue}.',
  'err.min': 'O campo "{fieldName}" deve ser superior ao valor mínimo permitido.',
  'updateField.desc': 'Por favor, forneça as informações atualizadas para o seguinte campo: <b>{field}</b>',
  'marital.status.engaged': 'Engajado',
  'payment_status.desc.DYN.passport_booked.toPay': 'A solicitação de documento foi reservada e ainda precisa ser paga.',
  'payment_status.desc.DYN.passport_booked': 'A solicitação de documento foi reservada e paga.',
  'place.notExist': 'O local não existe',
  'ApplicationForm': 'Formulário de aplicação',
  'BirthCertificate': 'Certificado de nascimento',
  'ParentalAuthorization': 'Autorização parental',
  'printSettings.selected': 'Você está modificando as configurações de impressão para o documento: <b>{documentName}</b>',
  'print.settings.success': 'As configurações de impressão foram atualizadas com sucesso para o documento: <b>{documentName}</b>',
  'error.noHasFace': 'Nenhum rosto foi detectado na foto. Por favor, tire a foto novamente.',
  'name.warn': 'O nome e/ou o sobrenome está vazio ou contém menos de 2 caracteres.',
  'kiosk.redirect': 'A sua nacionalidade não permite continuar no modo quiosque. Por favor, conecte-se com uma conta para prosseguir. Você será redirecionado para a tela de login.',
  'err.OtherPurpose.required': 'O campo "Outro motivo" é obrigatório',
  'print.qr.verification': 'Verificação',
  'print.qr.application': 'Pedido',
  'movements.empty': 'Nenhum movimento foi registrado até o momento.',
  'print.terms': 'Aplicam-se os termos e condições.',
  'movement.history': 'Histórico de entrada/saída',
  'payment.notes': 'Notas',
  'payment.noNotes': 'Nenhuma nota disponível',
  'extension.alreadyExists.warning': 'Já existe uma extensão para este pedido. Tem certeza de que deseja criar uma nova?',
  'payment.addNote.placeholder': 'Adicionar uma nota…',
  'payment.addNote.success': 'A nota foi adicionada com sucesso.',
  'global.seeMore': 'Ver mais',
  'global.seeLess': 'Ver menos',
  'BirthCity': 'Cidade de nascimento',
  'err.hostPhone.pattern': 'O número de telefone deve começar com + (código do país) ou 0 e conter entre 7 e 15 dígitos.',
  'reprintSticker': 'Reimprimir o autocolante',
  'err.daysGranted.max': 'O número de dias não pode exceder o número de dias solicitados.',
  'err.daysGranted.min': 'O número de dias deve ser no mínimo 1.',
  'err.daysGranted.required': 'O número de dias é obrigatório.',
  'approval.daysGranted.error': 'Por favor, insira um número válido de dias.',
  'err.password.pattern': 'A palavra-passe deve conter pelo menos dois dos seguintes elementos: uma letra minúscula, uma letra maiúscula, um número ou um caractere especial.',
  'err.documentNumber.pattern': 'O número do documento deve conter apenas letras, números, espaços e hífens.',
  'ask.borderpass': 'É realmente um passe fronteiriço?',
  'err.ExistingValidEntryReference.required': 'A referência de entrada válida existente é obrigatória',
  'BirthCountry': 'País de nascimento',
  'old': 'Senha antiga',
  'firstName': 'Nome',
  'email': 'Email',
  'paymentMethod': 'Método de pagamento',
  'client.extended.softLockedOutLogin30Minutes': 'Você foi bloqueado por 30 minutos. Por favor, tente novamente mais tarde.',
  'password': 'Senha',
  'password2': 'Confirmar senha',
  'PreviousConvictions': 'Convites',
  'Address': 'Endereço',
  'err.err': 'Erro',
  'err.mustBeEqualOrAfter.errorValue': 'O campo "{fieldName}" deve ser uma data igual ou posterior a {errorValue}.',
  'err.maxDateMilliTo.errorValue': 'O campo "{fieldName}" deve ser uma data igual ou anterior a {errorValue}.',
  'err.mustBeEqualOrBefore.errorValue': 'O campo "{fieldName}" deve ser uma data igual ou posterior a {errorValue}.',
  'err.minDateMilliFromNow.errorValue': 'O campo "{fieldName}" deve ser uma data igual ou posterior a {errorValue}.',
  'err.maxDateMilliFromNow.errorValue': 'O campo "{fieldName}" deve ser uma data igual ou anterior a {errorValue}.',
  'err.minDateMilliFromNow': 'O campo "{fieldName}" deve ser uma data igual ou posterior à data mínima permitida.',
  'err.maxDateMilliFromNow': 'O campo "{fieldName}" deve ser uma data igual ou anterior à data máxima permitida.',
  'err.pattern.^[0-9]{6,14}$': 'O campo "{fieldName}" deve conter entre 6 e 14 dígitos.',
  'err.mustMatch': 'O campo {fieldName} deve corresponder ao campo equivalente.',
  'err.requireOneOf.errorValue': '{errorValue} deve ser fornecido',
  'err.requireOneOf.field': 'O campo \'{name}\'',
  'err.requireOneOf.separator': ' ou ',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': 'O campo "{fieldName}" deve conter entre 3 e 15 caracteres alfanuméricos, traços ou espaços.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'O campo "{fieldName}" deve conter entre 7 e 20 caracteres: números, espaços, traços ou parênteses.',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'O campo "{fieldName}" deve conter entre 5 e 20 caracteres alfanuméricos.',
  'err.pattern.^[0-9]{10}$': 'O campo "{fieldName}" deve conter exatamente 10 dígitos.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'O campo "{fieldName}" deve conter entre 5 e 20 caracteres alfanuméricos.',
  'err.pattern.^[0-9]{8,20}$': 'O campo "{fieldName}" deve conter entre 8 e 20 dígitos.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'O campo "{fieldName}" deve conter entre 5 e 15 caracteres alfanuméricos.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'O campo "{fieldName}" deve ser uma imagem JPEG ou JP2 codificada em base64 com um formato válido.',
  'err.pattern.^[a-z]$': 'O campo "{fieldName}" deve conter apenas uma letra minúscula.',
  "err.pattern.^[A-Z' -]*$": 'O campo "{fieldName}" deve conter apenas letras maiúsculas, apóstrofos, espaços e traços.',
  'err.pattern.^[0-9-]{6,15}$': 'O campo "{fieldName}" deve conter de 6 a 15 caracteres (apenas dígitos e traços).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'O campo "{fieldName}" deve conter um endereço de email válido.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'O campo "{fieldName}" deve conter uma imagem (JPEG, PNG, WebP) ou um PDF codificado em base64 com um formato válido.',
  'err.pattern.^[A-Z]{3}$': 'O campo "{fieldName}" deve conter exatamente três letras maiúsculas.',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'O campo "{fieldName}" deve conter um número de telefone válido, com ou sem indicativo, podendo incluir espaços, traços ou pontos.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'O campo "{fieldName}" deve conter um número de telefone internacional ou nacional válido (ex.: +1234567890 ou 0123456789).',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'O campo "{fieldName}" deve conter apenas letras, espaços e traços.',
  "err.pattern.^[a-zA-Z' -]*$": 'O campo "{fieldName}" deve conter apenas letras, espaços e traços.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'O campo "{fieldName}" deve conter apenas letras, números, espaços e traços.',
  'err.pattern.^[0-9]*$': 'O campo "{fieldName}" deve conter apenas números.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'O campo "{fieldName}" deve conter uma data válida.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'O campo "{fieldName}" deve começar com uma letra maiúscula e pode conter letras minúsculas, acentos, espaços, apóstrofos, traços ou pontos.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'O campo "{fieldName}" deve conter apenas letras (com ou sem acentos), espaços, apóstrofos, traços ou pontos.',
  'err.pattern.^[A-Z0-9]+$': 'O campo "{fieldName}" deve conter apenas letras maiúsculas e números.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'O campo "{fieldName}" deve começar com um "+" seguido de 1 a 4 dígitos (o primeiro dígito não pode ser 0).',
  'err.required': 'O campo "{fieldName}" é obrigatório.',
  'err.maxlength.errorValue': 'O campo "{fieldName}" deve conter no máximo {errorValue} caracteres.',
  'err.minlength.errorValue': 'O campo "{fieldName}" deve conter no mínimo {errorValue} caracteres.',
  'err.maxlength': 'O campo "{fieldName}" é demasiado longo.',
  'err.minlength': 'O campo "{fieldName}" é demasiado curto.',
  'err.pattern': 'O campo "{fieldName}" tem um formato inválido.',
  'err.email': 'O campo "{fieldName}" deve conter um endereço de email válido.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'Reserva confirmada!',
  'global.bookTimeSlot': 'Reservar horário',
  'client.extended.maxMonthlyPaymentsReached': 'Você atingiu o número máximo de pagamentos mensais. Por favor, entre em contato com o suporte.',
  'calendar.weekday.sunday': 'Dom',
  'calendar.weekday.monday': 'Seg',
  'calendar.weekday.tuesday': 'Ter',
  'calendar.weekday.wednesday': 'Qua',
  'calendar.weekday.thursday': 'Qui',
  'calendar.weekday.friday': 'Sex',
  'calendar.weekday.saturday': 'Sáb',
  'calendar.month.january': 'Janeiro',
  'calendar.month.february': 'Fevereiro',
  'calendar.month.march': 'Março',
  'calendar.month.april': 'Abril',
  'calendar.month.may': 'Maio',
  'calendar.month.june': 'Junho',
  'calendar.month.july': 'Julho',
  'calendar.month.august': 'Agosto',
  'calendar.month.september': 'Setembro',
  'calendar.month.october': 'Outubro',
  'calendar.month.november': 'Novembro',
  'calendar.month.december': 'Dezembro',
  'calendar.timeline.no_slots': 'Nenhum horário disponível para este dia',
  'calendar.timeline.available': 'Disponível',
  'calendar.timeline.spots_available': 'vagas disponíveis',
  'calendar.timeline.fully_booked': 'Totalmente reservado',
  'calendar.confirm_booking_title': 'Confirmar Reserva',
  'calendar.confirm_booking_message': 'Por favor, confirme que deseja reservar este horário.',
  'calendar.booking_in_progress': 'Reserva em andamento...',
  'calendar.please_wait': 'Por favor, aguarde enquanto processamos sua reserva.',
  'calendar.booking_error_title': 'Erro na Reserva',
  'calendar.booking_success_title': 'Reserva Confirmada!',
  'calendar.booking_success_message': 'Seu horário foi reservado com sucesso.',
  'calendar.proceed_to_payment': 'Prosseguir para Pagamento',
  'calendar.auto_proceed_message': 'Redirecionamento automático em...',
  'calendar.date': 'Data',
  'calendar.time': 'Hora',
  'calendar.place': 'Local',
  'calendar.loading_month': 'Carregando disponibilidade...',
  'extension.error.maxDays': 'Não pode solicitar mais de 30 dias por prorrogação.',
  'DYN.processed.NOTICES_ACCEPTED': 'Avisos validados',
  'notices_validated': 'Avisos validados',
  'err.daysUntilReport.pattern': 'O número de dias até o relatório deve ter um formato correto',
  'err.reportInterval.pattern': 'O intervalo de relatório deve ser um número maior ou igual a 0',
  'err.CompanionsSize.min': 'O número de companheiros deve ser pelo menos 1',
  'err.CompanionsSize.max': 'O número de companheiros é muito longo',
  'global.error': 'Ocorreu um erro. Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte.',
  'err.DurationOfStay.required': 'A duração da estadia é obrigatória',
  'err.DurationOfStay.min': 'A duração da estadia deve ser pelo menos 1 dia',
  'err.DurationOfStay.max': 'A duração da estadia é muito longa',
  'DurationOfStay': 'Duração da estadia (dias)',
  'tooltip.acceptNotices': 'Validar o aviso atual',
  'notices': 'Avisos',
  'ask.notices': 'Deseja validar o aviso?',
  'accept.notices': 'Validar aviso',
  'err.ModeOfTravel.required': 'O modo de viagem é obrigatório',
  'err.FlightNumber.required': 'O número de voo é obrigatório',
  'err.ShipNumber.required': 'O número de barco é obrigatório',
  'err.CarNumber.required': 'O número de carro é obrigatório',
  'err.BusNumber.required': 'O número de ônibus é obrigatório',
  'err.TrainNumber.required': 'O número de trem é obrigatório',
  'err.FlightNumber.pattern': 'O número de voo deve ter um formato correto',
  'err.ShipNumber.pattern': 'O número de barco deve ter um formato correto',
  'err.CarNumber.pattern': 'O número de carro deve ter um formato correto',
  'err.BusNumber.pattern': 'O número de ônibus deve ter um formato correto',
  'err.TrainNumber.pattern': 'O número de trem deve ter um formato correto',
  'ModeOfTravel': 'Modo de viagem',
  'FlightNumber': 'Número de voo',
  'downgrade.type.label': 'Tipo de visto alvo',
  'PreviousVisa': 'Visto anterior',
  'err.PreviousVisa.required': 'O visto anterior é obrigatório',
  'multipleEntry.warning': 'Atenção: os vistos de entrada múltipla são concedidos apenas a indivíduos que já obtiveram pelo menos um visto válido no passado. Será exigida uma cópia de um visto anterior.',
  'ask.downgradeType': 'Escolha o tipo de visto alvo',
  'err.approveRefuse.required': 'Por favor, selecione se deseja recomendar ou não.',
  'ask.downgrade.multiple': 'Tem certeza de que deseja alterar este visto para {type}?',
  'ShipNumber': 'Número de barco',
  'CarNumber': 'Número de carro',
  'BusNumber': 'Número de ônibus',
  'TrainNumber': 'Número de trem',
  'DYN.flight': 'Por avião',
  'DYN.ship': 'Por barco',
  'DYN.car': 'Por carro',
  'DYN.bus': 'Por ônibus',
  'DYN.train': 'Por trem',
  'DYN.foot': 'A pé',
  'expiredSinceTime': 'O pedido expirou há <b>{days} dias e {hours} horas</b>.',
  'smartTable.filter.sinceDays': 'Desde',
  'smartTable.filter.createAtStart': 'Data (início)',
  'smartTable.filter.createAtEnd': 'Data (fim)',
  'smartTable.filter.timeslotStart': 'Horário (início)',
  'smartTable.filter.timeslotEnd': 'Horário (fim)',
  'smartTable.filter.paymentExtStatus': 'Status da extensão',
  'smartTable.filter.paymentStatus': 'Status da aplicação',
  'smartTable.filter.overstay': 'Estadia excedida',
  'smartTable.filter.isUrgent': 'Urgente',
  'smartTable.filter.applicationType': 'Tipo de aplicação',
  'smartTable.operationId': 'Tipo de documento',
  'smartTable.usageUntil': 'Válido até',
  'smartTable.usageAfter': 'Válido a partir de',
  'smartTable.price': 'Preço',
  'smartTable.paymentStatus': 'Status de pagamento',
  'smartTable.isUrgent': 'Urgente',
  'smartTable.passportNumber': 'Número do passaporte',
  'smartTable.fullName': 'Nome completo',
  'smartTable.lastName': 'Sobrenome',
  'smartTable.firstName': 'Nome próprio',
  'smartTable.batchId': 'Referência da aplicação',
  'smartTable.nationality': 'Nacionalidade',
  'smartTable.internalReference': 'Referência HQ',
  'smartTable.lock': 'Trancar',
  'smartTable.applicationId': 'ID da aplicação',
  'smartTable.creationDate': 'Data de criação',
  'smartTable.email': 'E-mail',
  'smartTable.role': 'Papel',
  'smartTable.name': 'Nome',
  'smartTable.userId': 'ID do Usuário',
  'smartTable.id': 'ID',
  'smartTable.placeId': 'ID do local',
  'total': 'Total',
  'tooltip.consumeOfficer.OUT': 'O agente que fez o check-out da pessoa.',
  'tooltip.consumeOfficer.IN': 'O agente que fez o check-in da pessoa.',
  'DYN.document.OTHER': 'Documento',
  'DYN.document.IR': 'Permissão de residência',
  'DYN.document.D': 'Motorista',
  'DYN.document.ID': 'Cartão de identidade',
  'DYN.document.P': 'Passaporte',
  'scanned': 'Digitalizado',
  'DYN.form.documentNumber.scanned': 'número do {documento}',
  'ask.isExtension.confirm': 'Você confirma que o pagamento foi realizado? Se confirmar, por favor insira a referência do pagamento, o método de pagamento e a moeda utilizada.',
  'DYN.role.5': 'Kiosco',
  'DYN.role.4': 'Registrador Parceiro',
  'DYN.role.3': 'Administrador',
  'DYN.role.2': 'Orbis Consumidor',
  'DYN.role.1': 'Funcionário',
  'DYN.role.0': 'Cliente',
  'DYN.role.6': 'Monitor Externo',
  'continue': 'Continuar',
  'global.changePassword': 'Alterar senha',
  'signIn.forgotPassword': 'Esqueci a senha',
  'signIn.title': 'Entrar',
  'global.notAccount': 'Ainda não tem uma conta?',
  'global.continue': 'Continuar',
  'Occupation': 'Ocupação',
  'signUp.title': 'Criar conta',
  'DYN.selectedPaymentMethod.VISA': 'Você selecionou pagar com <b>Visa</b>.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'Você selecionou pagar com <b>Mastercard</b>.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'Você selecionou pagar com <b>American Express</b>.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'Você selecionou pagar com <b>Diner\'s Club</b>.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'Você selecionou pagar com <b>Union Pay</b>.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'Você selecionou pagar com <b>Zimswitch</b>.',
  'DYN.selectedPaymentMethod.PAYPAL': 'Você selecionou pagar com <b>PayPal</b>.',
  'DYN.selectedPaymentMethod.DISCOVER': 'Você selecionou pagar com <b>Discover</b>.',
  'ProvisionnalEntryPort': 'Ponto de registro desejado',
  'payment_status.desc.offlineApplication': 'Este aplicativo está sendo processado atualmente <b>OFFLINE</b>. Prosseguir com o processo, que será enviado para a fila de sincronização uma vez concluído.',
  'warn.payment.offlineApplication.quit': 'Você está prestes a sair do processo de aplicação offline. Tem certeza de que deseja prosseguir?<br><br><b>Todos os dados serão perdidos.</b>',
  'consumeMode.transit': 'Você está atualmente em <b>modo de trânsito</b>, as aplicações serão automaticamente <b>processadas ENTRADA e SAÍDA ao mesmo tempo</b>. Este modo é utilizado para viajantes que estão em trânsito e não precisam permanecer no país.',
  'no_apply.overstay': 'Sem taxa',
  'apply.overstay': 'Taxa de aplicação',
  'paymentExtension.overstay': 'Esta aplicação está atualmente em excesso de permanência.<br><br><strong>Preço Base da Extensão:</strong> {basePrice}<br><strong>Penalidade de Excesso:</strong> {penalty}<br><strong>Total com Penalidade:</strong> {totalPrice}<br><br>Você pode escolher se a taxa de excesso deve ser aplicada ou não.',
  'clear.storage.tooltip': 'Limpe todos os dados armazenados localmente da aplicação',
  'clear.storage': 'Limpe o armazenamento',
  'ask.clear.storage': '<b>Esta ação realizará uma limpeza completa dos dados do site, similar ao recurso "Limpar dados do site" do Chrome.</b><br>Isso limpará: localStorage, sessionStorage, IndexedDB, Cache Storage, Service Workers, Cookies e outros armazenamentos do navegador. Todos os dados ainda na fila serão baixados em um arquivo JSON antes de serem apagados.<br><br>Tem certeza de que deseja continuar?',
  'download.logs.tooltip': 'Baixe os logs completos das atividades incomuns online e offline. Este arquivo será baixado no formato JSON e é principalmente utilizado para fins de depuração.',
  'download.logs': 'Baixar logs',
  'scan.noExitFound.wrongPassportType': 'Foi encontrado um ou mais estados "Pronto para check-out" para esta pessoa, mas o tipo de passaporte não corresponde ao documento digitalizado.<br> <b>Por favor, crie uma nova saída para esta pessoa.</b>',
  'scan.noEntryFound.wrongPassportType': 'Foi encontrado um ou mais estados "Pronto para check-in" para esta pessoa, mas o tipo de passaporte não corresponde ao documento digitalizado.<br> <b>Por favor, crie uma nova entrada para esta pessoa.</b>',
  'customerName': 'Nome do cliente',
  'ask.localUsageUntil.confirm': 'Aqui você pode alterar a data máxima de saída. Você só pode diminuir a data, escolhendo entre 1 e {days} dias',
  'localUsageUntil.ask': 'Digite os dias (data atual: {calculatedDate})',
  'time.year': '{value} ano',
  'time.months': '{value} meses',
  'time.month': '{value} mês',
  'time.weeks': '{value} semanas',
  'time.week': '{value} semana',
  'time.days': '{value} dias',
  'time.day': '{value} dia',
  'paymentUntil.gracePeriod': 'A seguinte aplicação está atualmente em período de graça, que termina em <b>{date}</b>. <br><br> Você pode escolher se a taxa por permanência prolongada deve ser aplicada ou não.',
  'payment.consume.placeNotAllowed': 'Este aplicativo não pode ser processado nesta localização. O viajante deve prosseguir para uma das seguintes localizações: <br><b>{places}</b>',
  'tooltip.externalIndexedData': 'Vários passaportes foram encontrados para esta pessoa.',
  'visaDocumentsMaxTotalSize': 'O tamanho total dos documentos carregados excede o tamanho máximo permitido de {size}Mb. Por favor, reduza o tamanho dos documentos e tente novamente.',
  'global.connection.timeout': 'A conexão foi interrompida. Verifique sua conexão com a Internet e tente novamente.',
  'help': 'Ajuda',
  'unlimited': 'Ilimitado',
  'application.placeAllowed': '<b>RESTRIÇÃO DE LOCALIZAÇÃO:</b> Este documento só pode ser processado nos seguintes locais: <b>{places}</b>',
  'no.must_pay': 'Pagamento ainda necessário',
  'existingValidEntryReference.desc': 'Esta aplicação contém uma <b>referência de entrada válida</b>. Isso significa que o viajante já pagou e recebeu autorização de entrada. Por favor, certifique-se de verificar a validade da referência antes de prosseguir. Se tudo estiver correto, você pode proceder com o check-in.',
  'ExistingValidEntryReference': 'Referência de entrada válida existente',
  'supervision.catC.ordinary.entry': 'CHECK-IN',
  'supervision.catC.ordinary.refuse': 'ENTRADA RECUSADA',
  'error.updatePassport': 'Ocorreu um erro ao atualizar a aplicação. Por favor, tente novamente.',
  'open.visaReference': 'Abrir aplicação vinculada',
  'title.visaReference': 'Aplicação vinculada',
  'print.extension': 'Imprimir extensão',
  'documents.load': 'Carregar todos os documentos',
  'documents.add': 'Adicionar documento em falta',
  'done.closeApplication': 'A aplicação foi encerrada com sucesso. Gostaria de criar uma nova aplicação com base nos dados desta?',
  'ask.closeApplication': 'Esta ação pode ser usada quando um viajante pode fornecer prova de que uma operação foi concluída offline, permitindo que este registro seja considerado resolvido e descartado. Por favor, confirme que deseja encerrar este pedido. Esta ação é final e não pode ser desfeita.',
  'approval.daysGranted.limit': 'O número de dias concedidos não pode exceder os {days} dias solicitados.',
  'approval.daysGranted.DYN.': 'Nr. de dias concedidos',
  'print.alreadyPrinted': 'Os documentos desta aplicação foram impressos pela última vez em {date} pelo usuário {user}. Gostaria de imprimi-los novamente?',
  'tooltip.printEvents': 'Uma lista de todos os eventos de impressão desta aplicação',
  'printEventsCollapse': 'Todos os eventos de impressão desta aplicação',
  'transactionReference.alt': 'Referência da Transação',
  'paymentType.alt': 'Tipo de Pagamento',
  'changeGender.ask': 'O gênero na aplicação deve ser alterado para Masculino ou Feminino.',
  'print.askMultiple': 'Gostaria de incluir todos os documentos relacionados na impressão?',
  'application.id': 'ID da Aplicação',
  'printSticker': 'Imprimir adesivo de visto',
  'correctionFields': 'Os seguintes campos foram corrigidos:',
  'corrected.desc': 'Esta aplicação de visto foi corrigida pelo solicitante em {date}.',
  'recentlyCorrected': 'Corrigido',
  'visaValidFrom': 'Entrada válida a partir de',
  'visaValidUntil': 'Entrada válida até',
  'online': 'Online',
  'offline': 'Offline',
  'issuingOfficer.alt': 'Agente emissor',
  'placeOfIssue': 'Local de emissão',
  'tooltip.hasBeenCorrected': 'Esta aplicação foi corrigida pelo solicitante.',
  'tooltip.extendStay': 'Prorrogar a estadia do solicitante',
  'decisionLetter.title': 'Carta Oficial de Decisao de Visto',
  'decisionLetter.approval.title': 'Pedido de visto aprovado',
  'decisionLetter.refusal.title': 'Pedido de visto recusado',
  'decisionLetter.applicationId': 'ID do pedido',
  'decisionLetter.approvalDate': 'Data de aprovação',
  'decisionLetter.refusalDate': 'Data da recusa',
  'decisionLetter.dear': 'Caro',
  'decisionLetter.applicant': 'Requerente',
  'decisionLetter.documentType.application': 'Pedido de visto',
  'decisionLetter.documentType.extension': 'Extensão de estadia',
  'decisionLetter.approval.body1': 'O seu pedido de visto foi aprovado.',
  'decisionLetter.approval.body2': 'Por favor, apresente o codigo QR em anexo aquando da sua chegada a um Ponto de Entrada (PoE).',
  'decisionLetter.refusal.body1': 'O seu pedido de visto nao foi aprovado.',
  'decisionLetter.refusal.body2': 'Se necessario, pode submeter um novo pedido, garantindo que corrige quaisquer elementos que possam ter levado a recusa.',
  'decisionLetter.signature': 'Em nome do Diretor-Geral da Imigracao.',
  'printApprovalLetter': 'Imprimir carta de aprovação',
  'operation.REFUSEOUT': 'Saída recusada',
  'operation.REFUSEIN': 'Entrada recusada',
  'error.closeApplication': 'Ocorreu um erro ao encerrar a aplicação. Por favor, tente novamente.',
  'closeApplication': 'Marcar como encerrada',
  'tooltip.closeApplication': 'Marcar a aplicação como encerrada. Esta ação é irreversível.',
  'understand': 'Entendido',
  'ExtraDocument1': 'Documento extra nº1',
  'ExtraDocument2': 'Documento extra nº2',
  'ExtraDocument3': 'Documento extra nº3',
  'ExtraDocument4': 'Documento extra nº4',
  'ExtraDocument5': 'Documento extra nº5',
  'paperSize': 'Largura do papel',
  'change_lang': 'Alterar idioma',
  'queue.export.desc': 'Gostaria de exportar a fila atual para um arquivo JSON? <b>A sua fila local será excluída após a exportação</b>. Tem certeza de que deseja continuar?',
  'queue.export': 'Exportar para JSON',
  'queue.import': 'Importar fila de JSON',
  'nationality': 'Nacionalidade',
  'gender': 'Gênero',
  'HQReference': 'Referência HQ',
  'global.resetDefaults': 'Restaurar padrão',
  'shortcuts.desc': 'Você pode definir seus próprios atalhos de teclado abaixo. Clique na tecla que deseja configurar e pressione a tecla desejada no teclado.',
  'press.key': 'Pressione qualquer tecla para definir o atalho...',
  'dashboard.keyboardShortcuts': 'Atalhos do teclado',
  'tooltip.changeShortcuts': 'Alterar os atalhos do teclado',
  'global.changeShortcuts': 'Alterar atalhos',
  'retake_picture': 'Tirar foto novamente',
  'picture': 'Foto',
  'error.faceCheck': 'Ocorreu um erro ao processar a correspondência facial. Por favor, tente novamente.',
  'faceCheck.see_score': 'Pontuação da correspondência facial',
  'recommendOrNot': 'Recomendar ou não',
  'recommended': 'Recomendado',
  'not_recommended': 'Não recomendado',
  'error.downgrade': 'Ocorreu um erro ao rebaixar o pedido. Por favor, tente novamente.',
  'done.downgrade': 'O pedido foi rebaixado com sucesso.',
  'request.downgrade': 'Rebaixar',
  'request.extendStay': 'Prorrogar estadia',
  'ResidencePermitNumber': 'Número do Permissão de Residência',
  'error.payment.noInternalReference': 'Uma referência HQ é necessária para que esta aplicação seja revisada. Aguarde a referência ser fornecida.',
  'request.revision': 'Gostaria de ativar o Autoskip? Este recurso pulará automaticamente as etapas revisadas que não exigem sua entrada.',
  'notice.BORDER_PASS': 'Passe de Fronteira',
  'form.borderPassNumber': 'Número do passe de fronteira',
  'form.dateOfBirth': 'Data de nascimento',
  'form.issueDate': 'Data de emissão',
  'form.authorizedCrossingPoints': 'Pontos de cruzamento autorizados',
  'form.issuedBy': 'Emitido por',
  'form.externalCode': 'Código externo (ICAO)',
  'err.invoke': 'Erro',
  'ask.pendingRequest': 'Você tem uma correção pendente. Deseja abri-la agora?',
  'entry.confirmation': 'Você tem certeza de que todas as informações fornecidas estão corretas? Ao clicar em "Confirmar", você enviará a aplicação.',
  'free': 'Gratuito',
  'tooltip.prepareLandingVisa.desc': '<b>Aviso</b>, esta aplicação pode não estar no estado correto. Por favor, verifique cuidadosamente o documento fornecido pelo cliente para confirmar o estado exato desta aplicação. Como você está em <b>modo {consumeMode}</b>, você tem a opção de <b>forçar o processamento como {transfertMode}</b>, mesmo que o estado atual normalmente não permita, se você achar necessário.',
  'last_update': 'Última atualização',
  'count': 'Contagem',
  'tooltip.linkedExtensions': 'Esta é uma extensão de estadia. Clique para ver os detalhes.',
  'request.viewOutOfState.button': 'Forçar "{consumeMode}"',
  'extension': 'Extensão',
  'client.extended.badPaymentMetadata': 'Os metadados do pagamento são inválidos. Tente novamente ou entre em contato com o suporte se o problema persistir.',
  'DaysRequested': 'Dias solicitados',
  'extensions.desc': 'Extensão(ões) de estadia aguardando revisão',
  'extend': 'Prorrogar',
  'CheckboxVisaExtendFees': 'Confirmo que as informações fornecidas são verdadeiras e precisas e concordo com as taxas, os termos e a política de privacidade da extensão de estadia.',
  'AttestantDocument': 'Documento do atestante',
  'AffidavitCustody': 'Declaração de custódia',
  'CopyOfEntry': 'Cópia da entrada',
  'DepartureTicket': 'Bilhete de partida',
  'DYN.Self': 'Próprio',
  'DYN.Spouse/Dependent': 'Cônjuge/Dependente',
  'DYN.Employee/Employer': 'Empregado/Empregador',
  'DYN.Co-Director': 'Co-Diretor',
  'DYN.Lawyer': 'Advogado',
  'VisaReference': 'Referência do visto',
  'ReasonForExtension': 'Motivo da extensão',
  'AttestantID': 'ID do atestante',
  'AttestantName': 'Nome do atestante',
  'AttestantPhone': 'Telefone do atestante',
  'AttestantEmail': 'E-mail do atestante',
  'AttestantAddress': 'Endereço do atestante',
  'AttestantRelation': 'Relação com o atestante',
  'start_extend': 'Prorrogar a estadia',
  'visaExtend.title': 'Extensão de estadia',
  'days': 'dias',
  'day': 'dia',
  'kiosk.standby.text1': 'Comece preenchendo sua declaração em apenas alguns cliques neste tablet ou online.',
  'kiosk.standbyDesc.text1': 'Antes de começar, observe as seguintes informações:',
  'kiosk.standbyDesc.li1': 'Você estará preenchendo um formulário eletrônico que coleta seus dados pessoais e detalhes da viagem.',
  'kiosk.standbyDesc.li2': 'Todas as informações fornecidas devem ser precisas e corresponder aos seus documentos de viagem (passaporte, visto, etc.).',
  'kiosk.standbyDesc.li3': 'Após concluir o formulário, você pode ir diretamente ao balcão de imigração com seus documentos de identificação.',
  'kiosk.standbyDesc.li5': 'Se você tiver alguma dificuldade, não hesite em pedir ajuda à equipe no posto de fronteira.',
  'kiosk.standbyDesc.text2': 'Clique em "Começar" quando estiver pronto para completar sua declaração de entrada.',
  'kiosk.success.title': 'Aplicação enviada com sucesso',
  'kiosk.success.text1': 'Agora você pode se dirigir ao balcão de imigração com seus documentos de viagem. Um oficial fará as verificações finais e validará sua entrada no país.',
  'kiosk.success.text2': 'Se você tiver alguma dúvida ou dificuldade, peça assistência à equipe disponível.',
  'confirm.revision': 'Confirmar revisão',
  'print.isDone': 'A notificação foi impressa com sucesso? Certifique-se de fornecer a notificação impressa ao solicitante.',
  'form.hostPhone': 'Telefone do anfitrião',
  'transit': 'Trânsito',
  'conditionalEntry': 'Entrada condicional',
  'departure': 'Partida',
  'form.paragraph': 'Parágrafo',
  'form.dateOfRefusal': 'Data da recusa',
  'form.purpose': 'Propósito',
  'form.host': 'Anfitrião',
  'form.officer': 'Agente',
  'form.reportAt': 'Relatar em',
  'form.reportOn': 'Relatar em (data)',
  'form.reportInterval': 'Intervalo de relatórios',
  'notice.desc.RESTRICTION': 'O Aviso de Restrição Provisória informa o solicitante sobre os documentos necessários para concluir o processo. Você pode selecionar os documentos ausentes que o solicitante deve fornecer dentro de um período especificado.',
  'notice.REFUSAL': 'Aviso de Entrada Recusada',
  'notice.desc.REFUSAL': 'O solicitante teve sua entrada no país recusada.',
  'notice.desc.REPORTING': 'O aviso ao visitante permite que o solicitante entre/saia do país, mas pode estar sujeito a relatórios adicionais. Você pode selecionar os documentos ausentes que o solicitante deve fornecer dentro de um período especificado.',
  'form.stationReference': 'Referência da estação',
  'form.fullNames': 'Nome completo',
  'form.reportLocation': 'Local de relatório',
  'form.daysUntilReport': 'Dias até o relatório',
  'form.otherMissingDocument': 'Outro documento ausente',
  'form.residentialAddress': 'Endereço residencial',
  'form.businessAddress': 'Endereço comercial',
  'form.hqReference': 'Referência HQ',
  'residentPermit': 'Permissão de residência',
  'notice.title': 'Avisos disponíveis para impressão',
  'notice.desc': 'Por favor, selecione um aviso da lista abaixo. Após preencher os campos obrigatórios, você pode imprimir o aviso para o solicitante.',
  'notice.RESTRICTION': 'Aviso de Restrição Provisória',
  'notice.REPORTING': 'Aviso ao Visitante',
  'notice.RESTRICTION.desc': 'O solicitante deve fornecer os documentos ausentes dentro de um período especificado.',
  'notice.REFUSAL.desc': 'O solicitante teve sua entrada recusada no país.',
  'notice.REPORTING.desc': 'O solicitante teve a entrada permitida, mas pode estar sujeito a relatórios adicionais.',
  'passportType.kioskWarning': 'A nacionalidade selecionada está sob o regime da Categoria C. Por favor, dirija-se a um agente de imigração imediatamente.',
  'free.charge.total': 'O total é gratuito',
  'err.entryPoints': 'Ocorreu um erro ao carregar os pontos de entrada planejados',
  'summary.your_meta': 'Seus dados (clique para abrir)',
  'summary.payOnline': 'Prefiro pagar online agora em vez de no balcão ao chegar.',
  'summary.payOnline.desc': 'Selecionar a opção abaixo o levará à página de pagamento. Se você optar por não pagar online, pagará as taxas de visto no balcão ao chegar para os tipos de "Visto na chegada".',
  'summary.meta': 'Dados de (clique para abrir)',
  'EmergencyLastName': 'Sobrenome de contato de emergência',
  'EmergencyFirstName': 'Nome de contato de emergência',
  'EmergencyEmail': 'E-mail de contato de emergência',
  'EmergencyPhone': 'Telefone de contato de emergência',
  'person.name': 'Nome da pessoa selecionada',
  'DYN.identity-card': 'Carteira de identidade',
  'DYN.resident-permit': 'Permissão de Residência Temporária',
  'DYN.identity-card.desc': 'Uma carteira de identidade é um documento emitido pelo governo usado para fins de identificação doméstica.',
  'DYN.resident-permit.desc': 'Uma Permissão de Residência Temporária é um documento oficial emitido por um governo permitindo que um estrangeiro resida no país por um período especificado.',
  'NonOrdinaryPassMission': 'Motivo da visita oficial',
  'PreviousConvictionsHomeAsk': 'Você ou algum de seus dependentes já foram condenados por algum crime em seu país de origem?',
  'PlaceOfBirthCountry': 'País de nascimento',
  'PlaceOfBirthCity': 'Cidade de nascimento',
  'OtherName': 'Outros nomes',
  'travelName': 'Referência da aplicação',
  'plannedEntry': 'Ponto de entrada planejado',
  'summary.title': 'Resumo',
  'urgent': 'Urgente',
  'visaType': 'Tipo de documento',
  'passportType': 'Tipo de identificação',
  'passportType.acknowledge': 'Ao selecionar este tipo de passaporte, você reconhece que o não cumprimento das condições de uso pode resultar na recusa de entrada.',
  'passportType.selectRefugeeNationality': 'Selecionar nacionalidade para passaporte de refugiado <br>',
  'form.travelName.already': '<b>Esta aplicação já foi enviada com a referência da aplicação abaixo. Se você deseja alterar a referência, comece uma nova aplicação.</b>',
  'application.current_person': 'Você está editando atualmente a aplicação para',
  'DYN.USD': '$ USD',
  'DYN.EUR': '€ EUR',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': '£ GBP',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'Editar os solicitantes',
  'request.existSaved': 'Foi encontrada uma aplicação salva. Gostaria de carregar seus dados? (Se clicar em "não", a aplicação será excluída e você começará uma nova.)',
  'participant.hasData': 'Você já inseriu dados para este participante. Se continuar, os dados serão perdidos. Tem certeza de que deseja continuar?',
  'participant.selectAtLeastOne': 'Por favor, selecione pelo menos um participante para continuar.',
  'participants.title': 'Solicitante(s)',
  'participants.desc': 'Por favor, selecione você e/ou as pessoas que farão parte desta aplicação.</br><b>O pagamento no final será feito para todas as pessoas selecionadas.</b></br></br>Você pode adicionar/remover uma pessoa ou editar a aplicação dela a qualquer momento clicando no nome que aparecerá acima do formulário.</br></br>{participantText}',
  'participant.ready': 'Quando estiver pronto, clique em "Continuar".',
  'participant.missing': 'Antes de continuar, crie pelo menos uma pessoa.',
  'travelName.title': 'Referência da aplicação',
  'form.travelName': 'Referência da aplicação',
  'form.travelName.desc': 'A referência da aplicação será usada para identificar sua aplicação mais facilmente.',
  'nationality.title': 'Nacionalidade',
  'nationality.desc': 'Por favor, selecione o seu país conforme o passaporte que está utilizando.',
  'passportType.title': 'Tipo de documento',
  'passportType.desc': 'Por favor, selecione o tipo de documento de viagem que está utilizando para esta solicitação.',
  'visaType.title': 'Tipo de visto',
  'visaType.desc': 'Por favor, selecione o tipo de visto que deseja solicitar. Esta lista varia dependendo da sua nacionalidade e tipo de passaporte.',
  'urgent.title': 'Visto Normal/Urgente',
  'urgent.desc': 'Se esta aplicação de visto for <b>urgente</b>, selecione esta opção. O tempo de processamento será mais curto, mas uma <b>taxa adicional</b> será cobrada.</br></br>',
  'priority.normal': 'Normal',
  'priority.urgent': 'Urgente',
  'priority.normal.DYN.desc': 'Processado dentro de sete (7) dias úteis.',
  'priority.urgent.DYN.desc': 'Processado dentro de três (3) dias úteis.',
  'visa.paidOnArrival.title': 'Visto pago na chegada',
  'visa.paidOnArrival.desc': 'Permite que viajantes elegíveis obtenham um visto na chegada ao porto de entrada de destino, simplificando o processo de entrada para visitas de curto prazo.',
  'visa.paidOnline.title': 'Visto pago online',
  'visa.paidOnline.desc': 'Permite uma ou mais entradas no país dentro de um período especificado de um (1) mês, exigindo um novo visto para entradas subsequentes.',
  'PassportType': 'Tipo de passaporte',
  'PassportCountry': 'País emissor do passaporte',
  'form.passportCountry': 'País emissor do passaporte',
  'DYN.ordinary': 'Passaporte comum',
  'DYN.diplomatic': 'Passaporte diplomático',
  'DYN.official': 'Passaporte oficial',
  'DYN.service': 'Passaporte de serviço',
  'DYN.refugee': 'Passaporte de refugiado ou Titre de Voyage',
  'open.register': 'Abrir registro',
  'supervision.nofee': 'Validação por um supervisor é necessária para uma solicitação sem penalidade.',
  'NoFeeProof': 'Comprovativo de isenção de taxa',
  'webcam.nofeeProof.confirm': 'Por favor, fotografe o documento comprovativo de isenção de taxa (No Fee Proof).',
  'DYN.ordinary.desc': 'Um passaporte comum é o tipo mais comum de passaporte, emitido para cidadãos com finalidades gerais de viagem.',
  'DYN.diplomatic.desc': 'Um passaporte diplomático é emitido para diplomatas e cônsules para viagens oficiais e residência no exterior.',
  'DYN.refugee.desc': 'Um passaporte de refugiado é emitido por um país para pessoas reconhecidas como refugiados com o objetivo de viajar ao exterior.',
  'DYN.official.desc': 'Um passaporte oficial é emitido para funcionários do governo para viagens e residência oficiais no exterior.',
  'DYN.service.desc': 'Um passaporte de serviço é emitido para funcionários do governo para viagens e residência oficiais no exterior.',
  'DYN.marine': 'Passaporte marítimo',
  'DYN.marine.desc': 'Um passaporte marítimo é emitido para marinheiros e membros da tripulação para viagens e residência no exterior.',
  'DYN.laissez-passer': 'Laissez-passer',
  'DYN.laissez-passer.desc': 'Um laissez-passer é um documento de viagem emitido pelas Nações Unidas ou suas agências para viagens e residência oficiais no exterior.',
  'Urgent': 'Esta é uma solicitação urgente. Entendo que o tempo de processamento será mais curto, mas as taxas serão mais altas.',
  'photo.passport.scanned': 'Passaporte escaneado agora',
  'review.nr.final': 'Revisão final',
  'review.nr': 'Revisão nº',
  'err.ArrivalDate.maxDateMilliTo': 'É necessário um período de pelo menos seis (6) meses entre a data de validade do seu passaporte e a data da sua chegada ao país. Por favor, renove este passaporte antes de aplicar para um visto.',
  'err.DateOfExpiry.maxDateMilliTo': 'Seu passaporte expira em menos de seis (6) meses a partir da data de chegada ao país. Por favor, renove este passaporte antes de aplicar para um visto.',
  'place.update.error': 'Ocorreu um erro ao atualizar o local',
  'dashboard.kiosk.start': 'Iniciar processo',
  'form.role.kiosk': 'Quiosque',
  'FundsAvailable': 'Montante',
  'FundsAvailableCurrency': 'Moeda',
  'emergency_contact_text': 'Em caso de emergência, forneça os detalhes de contato de uma pessoa que possa ser contatada.',
  'emergency_contact': 'Contato de emergência / Parente mais próximo',
  'err.BirthDay.mustBeEqualOrBefore': 'A data de nascimento deve ser igual ou anterior à data de emissão do passaporte.',
  'err.DateOfIssue.mustBeEqualOrAfter': 'A data de emissão deve ser igual ou posterior à data de nascimento.',
  'internet.lost': 'Conexão com a internet perdida.</br> Por favor, verifique sua conexão.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'Seu passaporte expira em menos de seis (6) meses a partir de hoje. Por favor, renove este passaporte antes de aplicar para um visto.',
  'err.DepartureDate.maxDateMilliFrom': 'A data de partida está muito distante da data de chegada. Consulte o limite de tempo do visto.',
  'requirements': 'Requisitos',
  'err.file.size': 'O tamanho do arquivo é muito grande. O tamanho máximo é:',
  'revision.success': 'A atualização da sua solicitação foi enviada com sucesso. Você receberá um e-mail com o QR code assim que for aprovado.',
  'revision.free': 'Revisão gratuita',
  'revision.start': 'Preenchemos os campos com as informações fornecidas no pedido inicial, exceto os campos que apresentam problemas. Verifique as informações e corrija-as. Deseja continuar?',
  'file_uploaded': 'Arquivo já enviado e armazenado',
  'refusal.desc2': 'Os seguintes campos apresentam problemas:',
  'start_correction': 'Iniciar correção',
  'payment.selectMode': 'Por favor, selecione os campos que apresentam problemas. Você pode selecionar vários campos.',
  'suspendReason.desc': 'Escreva uma breve descrição da solicitação de revisão. Esta descrição será enviada ao solicitante junto com os campos problemáticos selecionados.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'A data de chegada deve ser igual ou anterior à data de partida.',
  'err.DepartureDate.mustBeEqualOrAfter': 'A data de partida deve ser igual ou posterior à data de chegada.',
  'qr.request_desc': 'Este Código QR atua como um passe digital para o processamento de vistos. O governo reserva-se o direito de aprovar ou negar a entrada no momento do controle do visto.',
  'request_state.PENDING': 'Pendente',
  'document.Screening': 'Triagem',
  'err.SpouseBirthDay.max': 'Data de nascimento do cônjuge inválida.',
  'err.ArrivalDate.min': 'Data de chegada inválida.',
  'err.DepartureDate.min': 'Data de partida inválida.',
  'err.DateOfIssue.max': 'Data de emissão inválida',
  'err.BirthDay.max': 'Data de nascimento inválida',
  'err.dependants_date_of_birth.max': 'Data de nascimento do dependente inválida',
  'err.DateOfExpiry.min': 'Data de expiração inválida',
  'dependants': 'Dependentes',
  'male': 'Masculino',
  'female': 'Feminino',
  'other': 'Outro',
  'single': 'Solteiro(a)',
  'married': 'Casado(a)',
  'separated': 'Separado(a)',
  'divorced': 'Divorciado(a)',
  'widowed': 'Viúvo(a)',
  'select_reason_first': 'Por favor, selecione o motivo da visita na página anterior para ver a lista de documentos necessários.',
  'visaIntro.title': 'Aplicação',
  'remove': 'Remover',
  'dependant_add': 'Adicionar dependente',
  'dependant': 'Dependente',
  'upload_file': 'Carregar arquivo (< {size})',
  'PassportPhoto': 'Foto de rosto recente',
  'PassportScan': 'Página de dados biográficos do passaporte',
  'EventInvitationLetter': 'Carta de convite para o evento',
  'ProofOfResidenceHost': 'Comprovante de residência/reserva do anfitrião (assinado)',
  'AddressAtDestination': 'Endereço no destino',
  'HostInvitationLetter': 'Carta de convite do anfitrião',
  'ProofOfResidence': 'Comprovante de residência',
  'ApplicationLetter': 'Carta de aplicação',
  'ResidentialStatusOfHost': 'Status residencial do anfitrião',
  'ReasonOfVisitProof': 'Comprovante do motivo da visita',
  'BusinessLetter': 'Carta comercial/Carta individual',
  'BusinessProfile': 'Perfil comercial',
  'InvitationLetterAndBusinessProfile': 'Carta de convite e documentos da empresa anfitriã (assinados)',
  'InvitationLetter': 'Carta de convite',
  'LetterOfAcceptanceFromSchool': 'Carta de aceitação da escola',
  'DYN.male': 'Masculino',
  'DYN.female': 'Feminino',
  'DYN.other': 'Outro',
  'DYN.single': 'Solteiro(a)',
  'DYN.married': 'Casado(a)',
  'DYN.separated': 'Separado(a)',
  'DYN.divorced': 'Divorciado(a)',
  'DYN.widowed': 'Viúvo(a)',
  'DYN.married_according_to_custom': 'Casado(a) segundo as tradições',
  'DYN.religiously_married': 'Casado(a) segundo as tradições religiosas',
  'passport.valid': 'O documento escaneado não parece ter sido adulterado ou revogado e está assinado pelo país emissor.',
  'travel_information_title': 'Atenção',
  'visaPrice.desc': 'Você precisará fazer este pagamento por Visa ou MasterCard no final da aplicação. Este pagamento não é reembolsável.',
  'visaPrice': 'Preço do Visto',
  'required': 'Obrigatório',
  'DYN.holiday_visa': 'Férias',
  'DYN.live_here': 'Residente de longo prazo',
  'DYN.business_visa': 'Negócios',
  'DYN.conferencing_visa': 'Conferência',
  'DYN.transit_visa': 'Trânsito',
  'DYN.student_visa': 'Estudo',
  'DYN.sports_visa': 'Desporto',
  'DYN.arts_visa': 'Arte',
  'DYN.other_visa': 'Outro',
  'DYN.event_visa': 'Evento',
  'document': 'Documento',
  'documents_attached': 'Documentos a serem anexados',
  'Dependants': 'Dependentes',
  'dependants_name': 'Nome',
  'dependants_passport_number': 'Número do passaporte',
  'dependants_date_of_birth': 'Data de nascimento',
  'dependants_place_of_birth': 'Local de nascimento',
  'Spouse': 'Cônjuge',
  'SpouseFullName': 'Nome do cônjuge',
  'SpousePassportNumber': 'Número do passaporte do cônjuge',
  'SpouseBirthDay': 'Data de nascimento do cônjuge',
  'SpousePlaceOfBirth': 'Local de nascimento do cônjuge',
  'ArrivalDate': 'Data prevista de chegada',
  'DepartureDate': 'Data prevista de partida',
  'ReferencePreviousVisa': 'Referência do visto anterior',
  'PreviousConvictionsHome': 'Natureza das condenações no país de origem',
  'travel_information': 'Informações de viagem',
  'DateOfIssue': 'Data de emissão',
  'DateOfExpiry': 'Data de expiração',
  'PlaceofIssue': 'Local de emissão',
  'Email': 'E-mail',
  'Phone': 'Número de telefone',
  'HomeAddress': 'Endereço residencial atual',
  'HostName': 'Nome do anfitrião',
  'err.InvitingCompanyName.required': 'O nome da empresa convidante é obrigatório',
  'InvitingCompanyName': 'Nome da empresa convidante',
  'form.importantRead': 'IMPORTANTE - LEIA COM ATENÇÃO',
  'form.completeInEnglish': 'A ser preenchido claramente em inglês.',
  'form.selectApplicableFields': 'Selecione todos os campos aplicáveis abaixo.',
  'form.seniority': 'Grau de senioridade',
  'LastName': 'Sobrenome',
  'FirstName': 'Nome(s)',
  'BirthDay': 'Data de nascimento (Exatamente como no passaporte)',
  'PlaceOfBirth': 'Local de nascimento',
  'Gender': 'Gênero',
  'MaritalStatus': 'Estado civil',
  'CheckboxVisaFees': 'Confirmo que as informações fornecidas são verdadeiras e precisas e concordo com as taxas do visto, termos e política de privacidade.',
  'PassportNumber': 'Número do passaporte',
  'Nationality': 'Nacionalidade',
  'err.nationality.required': 'A nacionalidade é obrigatória.',
  'PurposeOfVisit': 'Motivo da visita',
  'VisaType': 'Tipo de visto',
  'visitor_details': 'Detalhes do solicitante',
  'personal_details': 'Detalhes pessoais',
  'contact_details': 'Detalhes de contato',
  'miscellaneous_details': 'Detalhes da viagem',
  'spouse_details': 'Detalhes do cônjuge',
  'payment': 'Pagamento',
  'global.scan_qr': 'Verificar código QR',
  'qr.nosuch': 'Carregando... Código QR ainda não encontrado no sistema. Verifique a conexão com a internet.',
  'qr.faked': 'Resposta do servidor: Código QR não existe. Provavelmente é falso!',
  'qr.quicklook': 'Informação principal',
  'global.toPayments.DYN.': 'Ver aplicações',
  'payment.duplicate.open': 'Abrir o novo pagamento?',
  'ONE_DAY': '1 dia',
  'THREE_DAYS': '3 dias',
  'ONE_WEEK': '1 semana',
  'TWO_WEEKS': '2 semanas',
  'ONE_MONTH': '1 mês',
  'TWO_MONTHS': '2 meses',
  'SIX_MONTHS': '6 meses',
  'ONE_YEAR': '1 ano',
  'place_created.desc': 'O novo local foi criado e agora está disponível.',
  'payment_status.DYN.NONE': '-- Sem filtro --',
  'dropdown.state': 'Status',
  'payment.qrList.title': 'Lista de pagamentos QR',
  'see.qr_list': 'Ver a lista de códigos QR',
  'form.role.partner_registrer': 'Registrar parceiro',
  'form.reason': 'Motivo',
  'global.reject': 'Rejeitar',
  'payment.validate_desc': 'Tem certeza de que deseja validar este pagamento?',
  'payment.reject_desc': 'Tem certeza de que deseja rejeitar este pagamento? Não se esqueça de adicionar um motivo.',
  'qr.title': 'Código QR',
  'dashboard': 'Painel de controle',
  'dashboard.people.DYN.': 'Pessoas salvas',
  'dashboard.my_account': 'Minha conta',
  'form.id': 'ID',
  'payments.scan': 'Escanear QR',
  'print.qr.desc': 'Este é um código QR único e seguro, pode ser usado apenas as vezes especificadas. Não o altere para mantê-lo utilizável.',
  'print.qr.title': 'Código QR',
  'print.informations': 'Informações',
  'print.notice.folding': 'Instruções de dobra',
  'print.notice.desc2': 'Em caso de dúvida referente a este documento, entre em contato com o suporte por telefone ou e-mail.',
  'print.notice.desc1': 'Mantenha este documento longe de água ou fogo.',
  'print.notice.title': 'Aviso',
  'client.extended.openSuchPayment': 'Um pagamento já está ativo para este usuário',
  'form.externalId': 'Referência de pagamento',
  'form.userExternalId': 'ID externo',
  'global.confirm': 'Confirmar',
  'global.submit': 'Enviar',
  'global.back': 'Voltar',
  'global.close': 'Fechar',
  'global.contact_support': 'Contatar suporte',
  'global.previous': 'Anterior',
  'global.next': 'Próximo',
  'global.accept': 'Aceitar',
  'global.support': 'Suporte',
  'global.consume': 'Consumir',
  'global.validate': 'Validar',
  'global.reset': 'Redefinir',
  'global.delete': 'Excluir',
  'global.update': 'Atualizar',
  'global.download': 'Baixar',
  'global.print': 'Imprimir',
  'global.print_c7': 'Imprimir bilhete',
  'global.checkIn': 'Check-in',
  'choose-lang.title': 'Preferência de idioma',
  'choose-lang.desc': 'Por favor, escolha o idioma que será usado para esta aplicação.',
  'global.personalNum': 'N° pessoal',
  'global.passportNum': 'N° do passaporte',
  'global.add': 'Adicionar',
  'global.block': 'Bloquear',
  'global.blocked': 'Bloqueado',
  'global.unblock': 'Desbloquear',
  'global.daily_otp': 'Código diário',
  'global.refresh': 'Atualizar',
  'global.connect': 'Conectar',
  'global.disconnect': 'Desconectar',
  'form.email': 'E-mail',
  'form.name': 'Nome',
  'form.firstName': 'Primeiro(s) nome(s)',
  'form.lastName': 'Sobrenome',
  'form.password': 'Senha',
  'form.password2': 'Digite novamente a senha',
  'form.linkType': 'Qual é o vínculo dessa pessoa com você?',
  'form.userId': 'ID do usuário',
  'form.parentId': 'ID do responsável',
  'form.amount': 'Quantia',
  'form.currency': 'Moeda',
  'form.buyingOption': 'Documento comprado',
  'form.place': 'Local',
  'form.role': 'Papel',
  'form.connectUAPattern': 'Padrão do agente de usuário',
  'form.connectIPRange': 'Intervalo de IP',
  'form.state': 'Estado',
  'form.created_date': 'Data de criação',
  'form.created_place': 'Local de criação',
  'form.consumed_place': 'Local consumido',
  'form.email_code': 'Código do e-mail',
  'form.phone': 'Número de telefone',
  'form.worker': 'ID do funcionário',
  'form.password_old': 'Senha atual',
  'form.password_new': 'Nova senha',
  'form.idCard': 'N° do cartão de identidade',
  'form.type.CASH': 'Dinheiro',
  'form.type.CARD': 'Cartão',
  'form.role.customer': 'Cliente',
  'form.role.worker': 'Funcionário',
  'yes': 'Sim',
  'no': 'Não',
  'form.borderPass': 'Emitir passe de fronteira',
  'form.role.orbis_consumer': 'Consumidor Orbis',
  'form.role.admin': 'Admin',
  'form.perm2.DYN.': 'Consumir uma aplicação de visto',
  'form.perm3.DYN.': 'Revisar uma aplicação de visto',
  'form.perm4.DYN.': 'Criar/gerenciar locais, usuários e aplicações de visto',
  'client.extended.clientNotAllowed': 'Sua conta atualmente não é permitida neste local. Verifique suas configurações de conexão.',
  'err.submit': 'Erro ao enviar o formulário',
  'err.place.required': 'O local é obrigatório',
  'err.noSmsPerm': 'O direito de SMS não foi concedido',
  'err.noSmsReceive': 'Não é possível vincular à leitura de SMS',
  'helps.showProceed': 'Mostrar continuação',
  'helps.showScan': 'Mostrar documento escaneado',
  'payment_status.DYN.undefined': 'Estado atual - não é uma operação',
  'client.extended.missingResourceLogin': 'Não foi possível conectar, credenciais incorretas',
  'client.extended.linkedAccountExists': 'Uma conta com este e-mail já existe',
  'client.extended.attachedPayments': 'Você não pode modificar esta pessoa, ela já tem uma aplicação vinculada.',
  'client.extended.badPayload': 'Informação incorreta na solicitação',
  'client.extended.placeNotAllowed': 'Local não permitido',
  'client.extended.locked': 'Conta bloqueada',
  'client.extended.clientBadOtp': 'Código diário incorreto',
  'client.extended.confirmationRequired': 'Confirmação necessária',
  'confirmationRequired.email': 'Um link de confirmação foi enviado para o seu e-mail. Verifique sua caixa de entrada e confirme antes de entrar.',
  'confirmationRequired.sms': 'Um link de confirmação foi enviado por SMS. Verifique suas mensagens e confirme antes de entrar.',
  'client.extended.badPaymentConfirmation': 'O pagamento não pode prosseguir: uma das verificações falhou',
  'time': 'Hora',
  'place': 'Local',
  'home.first': 'Sua conta foi validada e você pode fazer login.',
  'payOnline': 'Pagar online',
  'login.sign_in': 'Entrar',
  'photo.unavailable': 'Foto indisponível',
  'global.entry': 'Entrada',
  'global.exit': 'Saída',
  'menu.users': 'Usuários',
  'menu.places': 'Locais',
  'create_user.title': 'Criar um usuário',
  'create_payment.title': 'Criar um pagamento',
  'create_place.title': 'Criar um local',
  'users.title': 'Banco de dados de usuários',
  'payments.title': 'Banco de dados de pagamentos',
  'payments.download_csv': 'Baixar CSV',
  'create_card_payment.title': 'Pagamento online',
  'places.title': 'Lista de locais',
  'forgot_password.title': 'Redefinir senha',
  'welcome.title_1.DYN.': 'Bem-vindo ao {appName}',
  'welcome.text_1.DYN.': 'Bem-vindo ao portal oficial do {appName}.<br>Este serviço online facilita e torna seguro obter seus documentos oficiais.',
  'welcome.text_1.1.DYN.': 'Pronto para ver como funciona? Vamos começar!',
  'welcome.title_2.DYN.': 'O que é o {appName}?',
  'welcome.text_2.DYN.': 'O {appName} é uma plataforma digital segura que permite solicitar seus documentos oficiais online: carteira de identidade, passaporte, autorização de residência e muito mais.',
  'welcome.text_2.1.DYN.': 'Solicite de onde estiver e receba seus documentos por e-mail, com um código QR exclusivo que garante sua autenticidade.',
  'welcome.title_3.DYN.': 'Como trabalhador',
  'welcome.text_3.DYN.': 'Com o {appName}, você pode gerir os pedidos offline. Confiamos na nossa maneira segura e confiável de gerar códigos QR.',
  'welcome.text_3.1.DYN.': 'Você também pode gerir os utilizadores e os locais da sua organização.',
  'welcome.text_4.DYN.': 'Você pode até mesmo gerir os pedidos offline. Confiamos na nossa maneira segura e confiável de gerar códigos QR.',
  'welcome.text_4.1.DYN.': 'Assim que estiver online novamente, tudo será sincronizado automaticamente.',
  'welcome.title_5.DYN.': 'Inicie seu pedido',
  'welcome.text_5.DYN.': 'Nas páginas seguintes, você poderá solicitar seus documentos oficiais online em apenas alguns cliques.<br><br>Após a aprovação do seu pedido, você receberá os documentos por e-mail, com um código QR seguro contendo todas as informações necessárias para uma verificação rápida e confiável.',
  'payment_status.DYN.PROPOSED': 'Pagamento pendente',
  'payment_status.DYN.PAID': 'Pronto para check-in',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'Aguardando revisão',
  'payment_status.DYN.USED': 'Saída registrada',
  'payment_status.DYN.DUPLICATED': 'Duplicado',
  'payment_status.DYN.REFUNDED': 'Reembolsado',
  'payment_status.DYN.EXPIRED': 'Recusado',
  'payment_status.DYN.PENDING': 'Correção pendente',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'Pagar depois - Não confirmado',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'Gratuito - Não confirmado',
  'payment_status.DYN.DELAY_PAY': 'Pronto para pagar na chegada',
  'payments.validate': 'Confirmar',
  'documentContinue.title': 'Continuar comprando',
  'bt.available_devices': 'Dispositivos Bluetooth disponíveis',
  'bt.no_available_devices': 'Nenhum dispositivo Bluetooth detectado.',
  'emailSend.title': 'Verificação de e-mail',
  'emailSend.description': 'Para validar sua conta, clique no link contido em um e-mail enviado para seu endereço de e-mail em até 24 horas.',
  'emailValid.title': 'Conta validada',
  'emailValid.description': 'Sua conta {appName} foi validada com sucesso. Agora você pode acessar sua área pessoal fazendo login.',
  'documentManagement.title': 'Solicitação de visto',
  'preenroll.title': 'Pré-inscrição',
  'passportEmbassy.title': 'Passaporte de embaixada',
  'zwevisa.title': 'Visto',
  'passwordSend.title': 'Confirmação enviada',
  'passwordSend.description': 'Você recebeu um e-mail de confirmação com um link para redefinir sua senha. Clique no link em até 24 horas.',
  'forgotPassword.title': 'Esqueceu a senha?',
  'forgotPassword.description': 'Para redefinir sua senha, insira o e-mail da sua conta abaixo.',
  'forgotPassword.description.electron': 'Para redefinir sua senha, insira o e-mail da conta abaixo. Se for uma conta de <b>diretório ativo</b>, contate o suporte.',
  'passwordNew.title': 'Nova senha',
  'modifiedPassword.title': 'Senha alterada',
  'modifiedPassword.description': 'A senha foi alterada. Faça login novamente.',
  'people.title.DYN.': 'Pessoas salvas',
  'people.addPerson.DYN.': 'Criar nova pessoa',
  'meansPayment.title': 'Meios de pagamento',
  'onlinePayment.title': 'Pagamento PayPal',
  'onlinePayment.pay': 'Pagar',
  'qrPayment.title': 'Pagamento por código QR',
  'form.expireDate': 'Data de validade',
  'successPayment.title': 'Confirmação de pedido',
  'trackingControl.title.DYN.': 'Acompanhar esta solicitação',
  'modifyData': 'Modificar dados',
  'stopModifyData': 'Parar modificação de dados',
  'askVisa': 'Solicitar visto',
  'peopleNew.title.DYN.': 'Nova pessoa',
  'peopleFound.title.DYN.': 'Pessoa encontrada',
  'peopleFound.description.DYN.': 'A pessoa correspondente às informações fornecidas foi adicionada à lista de pessoas salvas.',
  'payment.commandHistory': 'Histórico de pagamentos',
  'menu.placesPerm': 'Locais e permissões',
  'block.message': 'Deseja bloquear este usuário?',
  'menu.addPlace': 'Adicionar local',
  'label.numberAccount': 'N° de conta',
  'place.sheet.open': 'Abrir detalhes do local',
  'place.delete': 'Remover vínculo com este local',
  'place.update.success': 'O local foi atualizado com sucesso.',
  'place.new': 'Novo local',
  'place.create': 'Criar local',
  'place.add.ask': 'Deseja vincular este local a este usuário?',
  'place.delete.link': 'Remover vínculo com local',
  'place.delete.link.ask': 'Tem certeza de que deseja desvincular este local?',
  'place.delete.link.done': 'Você desvinculou este local com sucesso.',
  'user.new': 'Novo usuário',
  'user.create': 'Criar usuário',
  'user.created': 'O novo usuário foi criado com sucesso. A conta agora pode ser usada.',
  'user.sheet.open': 'Abrir detalhes do usuário',
  'payment.sheet.open': 'Abrir detalhes do pagamento',
  'err.createplace': 'Não foi possível criar. ID já existe.',
  'place.parent': 'Local principal',
  'dropdown.qr': 'Escanear código QR',
  'dropdown.pass': 'Escanear documento',
  'info.testingReader': 'Verificando presença do leitor...',
  'info.testingReaderCard': 'Testando se o leitor possui cartão com chip...',
  'info.readingMrz': 'Lendo MRZ...',
  'info.connecting': 'Conectando ao chip...',
  'info.testingBAC': 'Executando Controle Básico de Acesso...',
  'info.readingCertificate': 'Lendo certificado de assinatura...',
  'info.doingPA': 'Executando Autenticação Passiva...',
  'info.readingDG': 'Lendo grupos de dados...',
  'info.disconnect': 'Desconectando...',
  'info.convertingImage': 'Convertendo imagem lida do documento...',
  'info.searchingPayment': 'Procurando aplicação nos servidores...',
  'info.readingPayment': 'Lendo informações detalhadas do servidor...',
  'err.noReader': 'O leitor não está conectado. Conecte o leitor para continuar.',
  'err.noCard': 'Nenhum documento biométrico válido detectado no leitor. Isso pode ser causado por um documento não biométrico, uma cópia não autorizada ou defeito na antena.',
  'err.noConnect': 'Este documento não segue os protocolos padrão da ICAO. Pode ser um documento não biométrico, uma cópia não autorizada ou defeito na antena.',
  'err.noBAC': 'Não foi possível estabelecer canal seguro com o documento. Verifique manualmente sua autenticidade e questione o portador.',
  'err.alteredDoc': 'Não foi possível ler os campos do documento. Verifique manualmente sua autenticidade.',
  'err.revokedDocSigner': 'O emissor deste documento foi revogado pela autoridade. Questione extensivamente o portador.',
  'err.unverifiedDoc': 'Autenticidade do documento não pôde ser verificada. Isso pode ser um documento fora dos padrões ou defeito na antena.',
  'err.noPassiveAuthentication': 'Validação passiva do documento falhou. Pode ser falsificação ou defeito na antena.',
  'err.noResult': 'Nenhum arquivo encontrado',
  'payment.new.DYN.': 'Nova saída sem visto',
  'payment.created.register': 'Pagamento registrado',
  'payment.created': 'Seu pagamento foi salvo e está visível na lista de pagamentos.',
  'payment.created.qr': 'Um e-mail contendo o código QR foi enviado para o endereço informado.',
  'idcard.number': 'Número do cartão de identidade',
  'form.userCreator': 'Criado pelo usuário',
  'form.userRefund': 'Reembolsado pelo usuário',
  'form.userConsumed': 'Consumido pelo usuário',
  'PRICEUP': 'Preço 0-9',
  'PRICEDOWN': 'Preço 9-0',
  'RECENT': 'Mais recentes',
  'LATEST': 'Mais antigos',
  'STATUSUP': 'Estado a-z',
  'STATUSDOWN': 'Estado z-a',
  'payment.success': 'Seu pagamento foi registrado.',
  'payment.consume.ask.DYN.': 'Deseja realmente registrar check-in/out deste visto?',
  'checkinOut.refuse': 'Deseja realmente recusar esta aplicação?',
  'payment.duplicate': 'Duplicar',
  'payment.duplicate.ask': 'Deseja duplicar este pagamento?',
  'payment.duplicate.done': 'O seu pagamento foi duplicado com sucesso',
  'tooltip.duplicatePayment': 'Duplicar este pagamento para permitir reutilização',
  'payment.refund.ask': 'Deseja reembolsar este pagamento?',
  'payment.refund.done': 'Seu pagamento foi reembolsado com sucesso.',
  'payment.refund.exist': 'Este pagamento já foi reembolsado.',
  'payment.paid.error': "Seu pagamento precisa estar no status 'Completo'.",
  'block.done': 'A conta foi bloqueada.',
  'block.unblock': 'A conta foi desbloqueada',
  'place-add.add': 'Adicionando local',
  'permission.title': 'Permissão necessária: Câmera',
  'qr.see': 'Ver o código QR',
  'qr.desc.DYN.': 'Aqui está o código QR para a aplicação. Ele aparecerá durante uma impressão e será enviado para o endereço de e-mail registrado.',
  'dashboard.place.verif': 'Se você não adicionou um local, por favor faça isso',
  'block.yourself': 'Você não pode se bloquear',
  'lastPlace.delete': 'O último local nesta conta está prestes a ser excluído. Isso tornará a conta inutilizável. Continuar?',
  'place.add.done': 'Este local foi adicionado com sucesso ao usuário',
  'no.connection': 'Para acessar esta página, você deve estar conectado à internet. Por favor, faça login novamente.',
  'place.delete.success': 'Este local foi excluído com sucesso.',
  'wrong.current': 'Você inseriu uma senha atual incorreta',
  'no.place': 'Nenhum local encontrado para esta conta.',
  'email.error': 'E-mail semelhante já existe',
  'email.notexist': 'E-mail não encontrado',
  'one.payment': 'Você deve ter pelo menos um ou mais pagamentos criados e/ou filtrados.',
  'err.client.extended.uuidUsed': 'Este pagamento já foi consumido',
  'client.extended.uuidUsed': 'Este pagamento já foi consumido',
  'no.activecamera': 'Nenhuma câmera ativa encontrada',
  'no.accessPermission': 'Esta conta não tem permissão de acesso',
  'print.name': 'Impressora',
  'print.success': 'Seu bilhete foi impresso com sucesso',
  'print.need': 'Você deve primeiro conectar-se a uma impressora para imprimir',
  'printer.connect': 'Você está conectado à impressora:',
  'permission.desc': 'O serviço que você deseja usar requer permissão para acessar a câmera do dispositivo',
  'createPeople.ask.DYN.': 'Você realmente deseja criar esta nova pessoa?',
  'createPeopleDuplicate.ask.DYN.': 'Parece que uma pessoa com o mesmo nome já está registrada. Deseja criar mesmo assim?',
  'deletePerson.DYN.': 'Excluir esta pessoa',
  'deletePerson.ask.DYN.': 'Tem certeza de que deseja excluir esta pessoa?',
  'deletePerson.valid.DYN.': 'A pessoa foi excluída com sucesso',
  'personModification.ask.DYN.': 'Tem certeza de que deseja modificar os dados desta pessoa?',
  'personModification.valid.DYN.': 'Os dados da pessoa foram modificados',
  'noPayment': 'Nenhum pagamento',
  'selfie.desc': 'Uma foto é necessária para a solicitação do documento. Certifique-se de estar em boa iluminação e segurar o telefone firmemente para evitar uma imagem desfocada. Certifique-se de que todos os detalhes do seu rosto estejam claramente visíveis na foto.',
  'ZWEVISA.title': 'Visto',
  'EMBASSYPASS.title': 'Passaporte da embaixada',
  'PREENROLL.title': 'Pré-inscrição',
  'DYN.NOK': 'Solicitação recusada',
  'WIP': 'Trabalho em progresso',
  'menu.requests.DYN.': 'Solicitações',
  'menu.createRequests.DYN.': 'Nova solicitação',
  'request_state.SUBMITTED': 'Enviado',
  'request_state.CONFIRMED': 'Confirmado',
  'request_state.TREATED': 'Processado',
  'request_state.TRANSFERRED': 'Transferido',
  'request_state.CANCELLED': 'Cancelado',
  'request_state.REFUSED': 'Recusado',
  'request_state.UNUSABLE': 'Inutilizável',
  'request_state.NULL': 'Não pago',
  'request_state.NONE': '-- Sem filtro --',
  'ask.disconnect': 'Tem certeza de que deseja desconectar?',
  'global.yes': 'Sim',
  'applicant.gender.male': 'Masculino',
  'applicant.gender.female': 'Feminino',
  'applicant.gender.other': 'Outro',
  'marital.status.single': 'Solteiro',
  'marital.status.married': 'Casado',
  'marital.status.separated': 'Separado',
  'marital.status.divorced': 'Divorciado',
  'marital.status.widowed': 'Viúvo',
  'marital.status.religiously_married': 'Casado(a) religiosamente',
  'marital.status.married_according_to_custom': 'Casado(a) segundo as tradições',
  'marital.status.other': 'Outro',
  'marital.status.unknown': 'Desconhecido',
  'request_state.PROPOSED': 'Pagamento pendente',
  'request_state.PAID': 'Completo',
  'request_state.USED': 'Encerrado',
  'request_state.DUPLICATED': 'Duplicado',
  'request_state.REFUNDED': 'Reembolsado',
  'request_state.EXPIRED': 'Recusado',
  'request_state.PAID_NOT_CONFIRMED': 'Aguardando revisão',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'Pagar depois - Não confirmado',
  'request_state.DELAY_PAY': 'Pronto para pagar na chegada',
  'payment_status.DYN.0': 'Pagamento pendente',
  'payment_status.DYN.1': 'Pronto para check-in',
  'payment_status.DYN.6': 'Aguardando revisão',
  'payment_status.DYN.2.9': 'Aguardando supervisão',
  'payment_status.DYN.2.10': 'Supervisionado',
  'payment_status.desc.DYN.2.10': 'A aplicação foi revisada por um supervisor e está pronta para processamento.',
  'payment_status.desc.DYN.2.9': 'A aplicação está aguardando supervisão. Um supervisor precisa revisá-la antes do processamento.',
  'payment_status.DYN.7': 'Aguardando correção',
  'payment_status.DYN.8': 'Aguardando revisão e pagar mais tarde',
  'payment_status.DYN.9': 'Pronto para pagar na chegada',
  'payment_status.DYN.9.entry': 'Pronto para check-in',
  'payment_status.DYN.9.exit': 'Pronto para check-out',
  'payment_status.DYN.2': 'Check-out concluído',
  'payment_status.DYN.3': 'Duplicado',
  'payment_status.DYN.4': 'Reembolsado',
  'payment_status.DYN.5': 'Recusado',
  'payment_status.extension.DYN.5': 'Extensão recusada',
  'payment_status.DYN.5.blacklisted': 'Recusado - Lista negra',
  'createPeople.success.DYN.': 'Pessoa criada com sucesso',
  'adminRequestResult.title.DYN.': 'Aplicação selecionada - {paymentID}',
  'form.paymentType': 'Tipo de pagamento',
  'payment.type.online': 'Online',
  'payment.type.offline': 'Offline',
  'request.state.DYN.': 'Estado da aplicação',
  'form.birthDate': 'Data de nascimento',
  'form.birthCountry': 'País de nascimento',
  'form.placeOfBirth': 'Cidade de nascimento',
  'form.residenceAdress': 'Endereço residencial',
  'form.maritalStatus': 'Estado civil',
  'form.departureDate': 'Data de partida',
  'form.arrivalDate': 'Data de chegada',
  'form.referencePreviousVisa': 'Referência do visto anterior',
  'form.passportNumber': 'Número do passaporte',
  'form.hostName': 'Nome do anfitrião',
  'form.purposeOfVisit': 'Motivo da visita',
  'form.previousConvictionsHome': 'Condenações anteriores no país de origem',
  'form.spouse.birthDay': 'Data de nascimento do cônjuge',
  'form.spousePassportNumber': 'Número do passaporte do cônjuge',
  'form.spousePlaceOfBirth': 'Local de nascimento do cônjuge',
  'form.dependantFullName': 'Nome completo do dependente',
  'form.dependantPassportNumber': 'Número do passaporte do dependente',
  'form.dependantPlaceOfBirth': 'Local de nascimento do dependente',
  'form.dependantBirthDay': 'Data de nascimento do dependente',
  'form.existingValidEntryReferenceOfficer': 'Responsável de referência de entrada',
  'officer.unknown': 'Responsável desconhecido',
  'global.approve': 'Aprovar',
  'global.refuse': 'Recusar',
  'global.suspend': 'Pedir revisão',
  'personal.data': 'Dados pessoais',
  'contact.data': 'Dados de contato',
  'divers.data.DYN.': 'Detalhes da viagem',
  'dependant.data': 'Dependentes',
  'spouse.data': 'Dados do cônjuge',
  'payment.review.approve.ask.DYN.': 'Você realmente deseja revisar esta aplicação de visto como <b>RECOMENDADA</b>?',
  'payment.review.refuse.ask.DYN.': 'Você realmente deseja revisar esta aplicação de visto como <b>NÃO RECOMENDADA</b>?',
  'payment.review.refuse.ask.extension.DYN.': 'Você realmente deseja revisar esta solicitação de extensão como <b>NÃO RECOMENDADA</b>?',
  'payment.review.approve.extension.ask.DYN.': 'Você realmente deseja <b>APROVAR</b> esta solicitação de extensão?',
  'payment.validate.ask.DYN.': 'Você realmente deseja <b>APROVAR</b> esta aplicação de visto?',
  'payment.validate.extension.ask.DYN.': 'Você realmente deseja <b>APROVAR</b> esta solicitação de extensão?',
  'error.payment.suspend.error.DYN.': 'Ocorreu um erro ao suspender a aplicação de visto.',
  'global.no': 'Não',
  'global.Yes': 'Sim',
  'global.No': 'Não',
  'documents': 'Documentos',
  'data.biographic': 'Página biográfica do passaporte',
  'residence.proof': 'Comprovante de residência',
  'address.destination': 'Endereço de destino',
  'previous.visa': 'Visto anterior',
  'invite.letter': 'Carta de convite',
  'hostInvitation.letter': 'Carta de convite do anfitrião',
  'proof.residenceHost': 'Comprovante de residência do anfitrião',
  'hostResidential.status': 'Status residencial do anfitrião',
  'reasonOfVisit.proof': 'Comprovante do motivo da visita ao país de destino',
  'inviteBusiness.letter': 'Carta comercial da empresa remetente',
  'business.profile': 'Perfil profissional do viajante',
  'application.letter': 'Carta de aplicação para visto',
  'acceptanceFromScool.letter': 'Carta de confirmação',
  'date.creation': 'Data de criação',
  'document.Passport': 'Passaporte',
  'completeName': 'Nome completo',
  'price': 'Preço',
  'global.retry': 'Tentar novamente',
  'err.loginWeak': 'Problema de conexão, tente novamente',
  'URGENTPASS.title': 'Passaporte urgente',
  'refusalReason': 'Motivo da recusa',
  'error.payment.noRefuseReason': 'Por favor, insira uma mensagem.',
  'error.payment.noSuspendReason': 'Por favor, insira um motivo para a suspensão. Este motivo será enviado ao cliente.',
  'refusal.desc.DYN.': 'Esta aplicação de visto foi recusada.',
  'refusal.desc.extension.DYN.': 'Esta solicitação de extensão foi recusada.',
  'approval.desc.DYN.': 'Esta aplicação de visto foi aprovada.',
  'approval.desc.extension.DYN.': 'Esta solicitação de extensão foi aprovada.',
  'review.approval.desc.DYN.': 'Esta aplicação de visto atende aos requisitos.',
  'review.approval.desc.extension.DYN.': 'Esta solicitação de extensão atende aos requisitos.',
  'review.refusal.desc.DYN.': 'Esta aplicação de visto não atende aos requisitos.',
  'review.refusal.desc.extension.DYN.': 'Esta solicitação de extensão não atende aos requisitos.',
  'err.getUsers: client.extended.notActiveToken': 'Sua sessão expirou. Por favor, faça login novamente.',
  'VISA_DOUBLE.title': 'Visto de entrada dupla',
  'VISA_KAZA.title': 'Visto Kaza',
  'history': 'Histórico',
  'menu.people.DYN.': 'Pessoas salvas',
  'DYN.XBA': 'African Development Bank',
  'DYN.AGO': 'Angola',
  'DYN.ABW': 'Aruba',
  'DYN.ATG': 'Antígua e Barbuda',
  'DYN.BHS': 'Bahamas',
  'DYN.BRB': 'Barbados',
  'DYN.BLZ': 'Belize',
  'DYN.BWA': 'Botsuana',
  'DYN.CYM': 'Ilhas Cayman',
  'DYN.CYP': 'Chipre',
  'DYN.FJI': 'Fiji',
  'DYN.COD': 'República Democrática do Congo',
  'DYN.GHA': 'Gana',
  'DYN.GRD': 'Granada',
  'DYN.HKG': 'Região Administrativa Especial de Hong Kong (China)',
  'DYN.KEN': 'Quênia',
  'DYN.KIR': 'Kiribati',
  'DYN.JAM': 'Jamaica',
  'DYN.LDW': 'Ilhas de Sotavento',
  'DYN.LSO': 'Lesoto',
  'DYN.MDG': 'Madagascar',
  'DYN.MWI': 'Malawi',
  'DYN.MYS': 'Malásia',
  'DYN.MDV': 'Maldivas',
  'DYN.MLT': 'Malta',
  'DYN.MUS': 'Maurício',
  'DYN.MSR': 'Montserrat',
  'DYN.MOZ': 'Moçambique',
  'DYN.NAM': 'Namíbia',
  'DYN.NRU': 'Nauru',
  'DYN.LCA': 'Santa Lúcia',
  'DYN.VCT': 'São Vicente e Granadinas',
  'DYN.WSM': 'Samoa Ocidental',
  'DYN.SYC': 'Seicheles',
  'DYN.SGP': 'Singapura',
  'DYN.SLB': 'Ilhas Salomão',
  'DYN.ZAF': 'África do Sul',
  'DYN.KNA': 'São Cristóvão e Nevis',
  'DYN.SWZ': 'Essuatíni',
  'DYN.TON': 'Tonga',
  'DYN.TTO': 'Trindade e Tobago',
  'DYN.TCA': 'Ilhas Turcas e Caicos',
  'DYN.TUV': 'Tuvalu',
  'DYN.UGA': 'Uganda',
  'DYN.TZA': 'República Unida da Tanzânia',
  'DYN.VUT': 'Vanuatu',
  'DYN.VAT': 'Vaticano',
  'DYN.VEN': 'Venezuela (República Bolivariana da)',
  'DYN.USA': 'Estados Unidos da América',
  'DYN.URY': 'Uruguai',
  'DYN.UZB': 'Uzbequistão',
  'DYN.UKR': 'Ucrânia',
  'DYN.ARE': 'Emirados Árabes Unidos',
  'DYN.GBR': 'Reino Unido da Grã-Bretanha e Irlanda do Norte',
  'DYN.TUR': 'Turquia',
  'DYN.TKM': 'Turcomenistão',
  'DYN.SWE': 'Suécia',
  'DYN.CHE': 'Suíça',
  'DYN.TJK': 'Tajiquistão',
  'DYN.KAZ': 'Cazaquistão',
  'DYN.SUR': 'Suriname',
  'DYN.ESP': 'Espanha',
  'DYN.SVK': 'Eslováquia',
  'DYN.SVN': 'Eslovênia',
  'DYN.SEN': 'Senegal',
  'DYN.SRB': 'Sérvia',
  'DYN.SMR': 'São Marino',
  'DYN.STP': 'São Tomé e Príncipe',
  'DYN.NLD': 'Países Baixos',
  'DYN.NCL': 'Nova Caledônia',
  'DYN.NZL': 'Nova Zelândia',
  'DYN.NIC': 'Nicarágua',
  'DYN.MEX': 'México',
  'DYN.FSM': 'Micronésia, Estados Federados da',
  'DYN.MDA': 'Moldávia',
  'DYN.MCO': 'Mônaco',
  'DYN.MHL': 'Ilhas Marshall',
  'DYN.LVA': 'Letônia',
  'DYN.NFK': 'Ilha Norfolk',
  'DYN.MNP': 'Ilhas Marianas do Norte',
  'DYN.NOR': 'Noruega',
  'DYN.PLW': 'Palau',
  'DYN.PSE': 'Palestina',
  'DYN.PAN': 'Panamá',
  'DYN.PNG': 'Papua-Nova Guiné',
  'DYN.PRY': 'Paraguai',
  'DYN.PER': 'Peru',
  'DYN.POL': 'Polônia',
  'DYN.PRT': 'Portugal',
  'DYN.PRI': 'Porto Rico',
  'DYN.REU': 'Reunião',
  'DYN.ROU': 'Romênia',
  'DYN.RUS': 'Federação Russa',
  'DYN.RWA': 'Ruanda',
  'DYN.LIE': 'Liechtenstein',
  'DYN.LTU': 'Lituânia',
  'DYN.LUX': 'Luxemburgo',
  'DYN.MAC': 'Região Administrativa Especial de Macau (China)',
  'DYN.JPN': 'Japão',
  'DYN.KWT': 'Kuwait',
  'DYN.KGZ': 'Quirguistão',
  'DYN.KOR': 'Coreia do Sul',
  'DYN.GUY': 'Guiana',
  'DYN.HTI': 'Haiti',
  'DYN.HND': 'Honduras',
  'DYN.IRL': 'Irlanda',
  'DYN.ISR': 'Israel',
  'DYN.ITA': 'Itália',
  'DYN.HUN': 'Hungria',
  'DYN.ISL': 'Islândia',
  'DYN.IND': 'Índia',
  'DYN.IDN': 'Indonésia',
  'DYN.IRN': 'Irã',
  'DYN.GUM': 'Guam',
  'DYN.GTM': 'Guatemala',
  'DYN.GIB': 'Gibraltar',
  'DYN.GRC': 'Grécia',
  'DYN.GEO': 'Geórgia',
  'DYN.DEU': 'Alemanha',
  'DYN.DNK': 'Dinamarca',
  'DYN.EST': 'Estônia',
  'DYN.ETH': 'Etiópia',
  'DYN.FIN': 'Finlândia',
  'DYN.FRA': 'França',
  'DYN.GUF': 'Guiana Francesa',
  'DYN.PYF': 'Polinésia Francesa',
  'DYN.ATF': 'Territórios Franceses do Sul',
  'DYN.CZE': 'República Tcheca',
  'DYN.COM': 'Comores',
  'DYN.DOM': 'República Dominicana',
  'DYN.ECU': 'Equador',
  'DYN.EGY': 'Egito',
  'DYN.SLV': 'El Salvador',
  'DYN.GNQ': 'Guiné Equatorial',
  'DYN.CHL': 'Chile',
  'DYN.CHN': 'China',
  'DYN.CHN_NT': 'China (não turística)',
  'DYN.COK': 'Ilhas Cook',
  'DYN.CRI': 'Costa Rica',
  'DYN.HRV': 'Croácia',
  'DYN.CUB': 'Cuba',
  'DYN.BDI': 'Burundi',
  'DYN.CAN': 'Canadá',
  'DYN.CPV': 'Cabo Verde',
  'DYN.BRA': 'Brasil',
  'DYN.VGB': 'Ilhas Virgens Britânicas',
  'DYN.BRN': 'Brunei Darussalam',
  'DYN.BGR': 'Bulgária',
  'DYN.BMU': 'Bermudas',
  'DYN.BTN': 'Butão',
  'DYN.BIH': 'Bósnia e Herzegovina',
  'DYN.BLR': 'Bielorrússia',
  'DYN.BEL': 'Bélgica',
  'DYN.BHR': 'Bahrein',
  'DYN.ARG': 'Argentina',
  'DYN.ARM': 'Armênia',
  'DYN.AUS': 'Austrália',
  'DYN.AUT': 'Áustria',
  'DYN.AZE': 'Azerbaijão',
  'DYN.ALB': 'Albânia',
  'DYN.DZA': 'Argélia',
  'DYN.AIA': 'Anguila',
  'DYN.BGD': 'Bangladesh',
  'DYN.BEN': 'Benin',
  'DYN.AFG': 'Afeganistão',
  'DYN.BOL': 'Bolívia',
  'DYN.BFA': 'Burquina Faso',
  'DYN.KHM': 'Camboja',
  'DYN.CMR': 'Camarões',
  'DYN.CIV': 'Costa do Marfim',
  'DYN.CAF': 'República Centro-Africana',
  'DYN.TCD': 'Chade',
  'DYN.COL': 'Colômbia',
  'DYN.ERI': 'Eritreia',
  'DYN.COG': 'Congo-Brazzaville',
  'DYN.PRK': 'República Popular Democrática da Coreia',
  'DYN.GAB': 'Gabão',
  'DYN.GMB': 'Gâmbia',
  'DYN.DJI': 'Djibuti',
  'DYN.GIN': 'Guiné-Conacri',
  'DYN.GNB': 'Guiné-Bissau',
  'DYN.IRQ': 'Iraque',
  'DYN.KOS': 'Kosovo',
  'DYN.LAO': 'República Democrática Popular do Laos',
  'DYN.JOR': 'Jordânia',
  'DYN.LBR': 'Libéria',
  'DYN.LBY': 'Jamahiriya Árabe Líbia',
  'DYN.MLI': 'Mali',
  'DYN.QAT': 'Catar',
  'DYN.REF': 'Refugiado',
  'DYN.PHL': 'Filipinas',
  'DYN.OMN': 'Omã',
  'DYN.PAK': 'Paquistão',
  'DYN.LBN': 'Líbano',
  'DYN.MRT': 'Mauritânia',
  'DYN.MNG': 'Mongólia',
  'DYN.MNE': 'Montenegro',
  'DYN.NER': 'Níger',
  'DYN.NGA': 'Nigéria',
  'DYN.MMR': 'Mianmar',
  'DYN.MAR': 'Marrocos',
  'DYN.NPL': 'Nepal',
  'DYN.SAU': 'Arábia Saudita',
  'DYN.SLE': 'Serra Leoa',
  'DYN.SOM': 'Somália',
  'DYN.LKA': 'Sri Lanka',
  'DYN.SSD': 'Sudão do Sul',
  'DYN.SDN': 'Sudão',
  'DYN.THA': 'Tailândia',
  'DYN.MKD': 'Antiga República Iugoslava da Macedônia',
  'DYN.TGO': 'Togo',
  'DYN.SYR': 'República Árabe Síria',
  'DYN.TWN': 'Taiwan',
  'DYN.TUN': 'Tunísia',
  'DYN.VNM': 'Vietnã',
  'DYN.YEM': 'Iêmen',
  'DYN.TLS': 'Timor-Leste',
  'DYN.AND': 'Andorra',
  'DYN.VIR': 'Ilhas Virgens (EUA)',
  'DYN.XKX': 'Kosovo',
  'DYN.ZWE': 'Zimbábue',
  'DYN.ZMB': 'Zâmbia',
  'DYN.ASM': 'Samoa Americana',
  'DYN.DMA': 'Dominica',
  'DYN.XXA': 'Apatridia',
  'DYN.XXB': 'Refugiado (Convenção de Genebra)',
  'DYN.XXC': 'Refugiado (Outro)',
  'DYN.UNA': 'Agência das Nações Unidas',
  'DYN.UNO': 'Organização das Nações Unidas',
  'document.type.DYN.': 'Tipo de aplicação',
  'dependantIndex': 'Dependente {index}',
  'form.spouseFullName': 'Nome completo do cônjuge',
  'qrDesc.valid': 'Apresente este código QR no ponto de controle de vistos ao entrar/sair do país. Você não pode viajar sem um código QR válido.',
  'err.pay': 'Ocorreu um erro durante o pagamento. Tente novamente.',
  'payment.noEvents': 'Esta aplicação atualmente não inclui nenhum processamento relacionado a viagens.',
  'global.cancel': 'Cancelar',
  'end.suspend': 'Finalizar a revisão',
  'trips.title': 'Acompanhar aplicações',
  'trips.desc': 'Solicitação(ões)',
  'BatchId': 'Referência da aplicação',
  'newBatchId.desc': 'Por favor, insira um nome para esta viagem.',
  'personLinkType.DYN.0': 'Desconhecido',
  'personLinkType.DYN.1': 'Criança',
  'personLinkType.DYN.2': 'Parente',
  'personLinkType.DYN.3': 'Cônjuge',
  'personLinkType.DYN.4': 'Outro',
  'personLinkType.DYN.5': 'Próprio',
  'batchIds.desc': 'Aplicações vinculadas à referência {trip} :',
  'trip.name': 'Referência da aplicação',
  'visaIntro.validFrom': 'Data de início',
  'visaIntro.validUntil': 'Data de expiração',
  'visaIntro.usageCount': 'Uso(s) permitido(s)',
  'client.extended.passportNumberAlreadyExists': 'Este número de passaporte já está em uso. Por favor, insira outro.',
  'client.extended.alreadyDecided': 'Esta aplicação de visto já foi revisada por você. Você não pode revisá-la novamente.',
  'client.extended.outOfUsage': 'Esta aplicação está <b>fora do seu período de validade</b>',
  'global.review': 'Revisar',
  'error.review.noChoice': 'Por favor, selecione um estado de revisão para continuar.',
  'all.reviews': 'Todas as revisões desta aplicação de visto',
  'all.reviews.extension': 'Todas as revisões desta solicitação de extensão',
  'validate.desc': 'Esta aplicação de visto foi revisada como aprovada em {date} pelo usuário',
  'printEvent.desc': 'Esta aplicação de visto foi impressa com todos os seus documentos em {date} pelo usuário',
  'validate.extension.desc': 'Esta solicitação de extensão foi revisada como aprovada em {date} pelo usuário',
  'refusal.review.desc': 'Esta aplicação de visto foi revisada como recusada em {date} pelo usuário',
  'refusal.review.extension.desc': 'Esta solicitação de extensão foi revisada como recusada em {date} pelo usuário',
  'refusal.review.desc.blacklisted': 'Esta aplicação de visto foi revisada como recusada e incluída na lista negra em {date} pelo usuário',
  'approve.text': 'Esta aplicação foi aprovada.',
  'pending.review.desc': 'Uma correção desta aplicação de visto foi solicitada ao solicitante em {date} pelo usuário',
  'global.reason': 'Motivo',
  'pending.desc': 'Esta aplicação de visto está atualmente aguardando correção do cliente.',
  'successRequest.title': 'Solicitação enviada com sucesso',
  'amountDue': 'Preço: ',
  'amountDue.total.now': 'Total devido agora: ',
  'amountDue.total.later': 'Total devido no guichê do oficial: ',
  'noPrint.mobile': 'A impressão da página não é suportada em dispositivos móveis',
  'onArrival.reset': 'Iniciar um novo processo',
  'onArrival.reset.ask': 'Você realmente deseja iniciar um novo processo?',
  'stillHere': 'Você ainda está aí? Este processo será redefinido em 20 segundos.',
  'print.request': 'Imprimir a aplicação',
  'EXPIRED.globalExplain': 'Esta solicitação foi recusada. Ela não está em conformidade com nossos padrões.',
  'payment_status.desc.DYN.7': 'Esta solicitação de visto está aguardando correção do cliente.',
  'payment_status.DYN.6.review': 'Aguardando revisão - {reviewCount}/2',
  'payment_status.extension.DYN.6': 'Aguardando revisão',
  'payment_status.extension.DYN.6.review': 'Aguardando revisão - {reviewCount}/1',
  'payment_status.DYN.8.review': 'Aguardando revisão',
  'payment_status.desc.DYN.6.review': 'Esta solicitação de visto está atualmente aguardando revisão. Já foi revisada {reviewCount} vez(es).',
  'payment_status.desc.DYN.8.review': 'Esta solicitação de visto está atualmente aguardando revisão pelo supervisor.',
  'payment_status.DYN.6.finalReview': 'Aguardando revisão final',
  'payment_status.extension.DYN.6.finalReview': 'Aguardando revisão final',
  'payment_status.desc.DYN.6.finalReview': 'Esta solicitação de visto foi revisada e está atualmente aguardando revisão final.',
  'payment_status.desc.DYN.0': 'Esta solicitação está atualmente pendente de validação de pagamento na instituição financeira. Se o pagamento ainda não foi efetuado, ele pode ser realizado agora.',
  'payment_status.desc.DYN.5': 'Esta solicitação de visto foi recusada.',
  'payment_status.desc.DYN.5.blacklisted': 'Esta solicitação de visto foi recusada e a pessoa foi colocada na lista negra.',
  'payment_status.desc.DYN.5.checkIn': 'Esta solicitação foi recusada durante o check-in na mesa do oficial.',
  'payment_status.desc.DYN.5.checkIn.reason': 'Esta solicitação foi recusada durante o check-in na mesa do oficial. <p><b>Motivo</b>: <br/> {reason}</p>',
  'payment_status.DYN.5.checkIn': 'Recusado no check-in',
  'payment_status.desc.DYN.5.checkOut': 'Esta solicitação foi recusada durante o check-out na mesa do oficial.',
  'payment_status.DYN.5.checkOut': 'Recusado no check-out',
  'payment_status.desc.DYN.9': 'Esta solicitação de visto está pronta para pagamento na mesa do oficial. O check-in pode ser concluído após o pagamento.',
  'payment_status.desc.DYN.9.entry': 'Esta solicitação está pronta para check-in na mesa do oficial.',
  'payment_status.desc.DYN.9.exit': 'Esta solicitação está pronta para check-out e requer pagamento para o passe de fronteira emitido na mesa do oficial.',
  'payment_status.DYN.2.out': 'Pronto para check-out',
  'payment_status.DYN.2.outFinish': 'Check-out concluído',
  'payment_status.DYN.2.closed': 'Encerrado',
  'payment_status.desc.DYN.2.closed': 'Esta solicitação foi encerrada.',
  'payment_status.desc.DYN.2.zweexit': 'Esta solicitação está pronta para check-out na mesa do oficial.',
  'payment_status.DYN.2.entryFinish': 'Check-in concluído',
  'payment_status.DYN.2.in': 'Pronto para check-in',
  'payment_status.desc.DYN.2.out': 'Esta solicitação foi verificada no check-in. O próximo passo é o check-out na mesa do oficial.',
  'payment_status.desc.DYN.2.outFinish': 'Esta solicitação foi verificada no check-out. O cliente agora pode viajar.',
  'payment_status.desc.DYN.2.entryFinish': 'Esta solicitação foi verificada no check-in. O cliente agora pode entrar no país.',
  'payment_status.desc.DYN.2.in': 'Esta solicitação aguarda check-in na mesa do oficial.',
  'ask.isArrivalPaid': 'O seguinte pagamento deve ser feito agora em qualquer uma das seguintes moedas:',
  'ask.isArrivalPaid.exit': 'O passe de fronteira deve ser pago agora em qualquer uma das seguintes moedas:',
  'ask.isArrivalPaid.confirm': 'Confirma que o pagamento foi efetuado? Se confirmar, por favor introduza a referência do pagamento, o método de pagamento e a moeda utilizada. Também pode alterar a data máxima de saída (só é possível antecipar a data, escolhendo entre 1 e {days} dias).',
  'ask.isArrivalPaid.confirm.exit': 'Você confirma que o pagamento foi feito? Se confirmar, insira a referência do pagamento e a moeda utilizada.',
  'ask.checkoutExpired.confirm': 'Você confirma que o pagamento foi feito? Se confirmar, insira a referência do pagamento e a moeda utilizada.',
  'no_trips': 'Você não tem viagens.',
  'err.canActivate': 'Ocorreu um erro',
  'form.passportNumber.dateOfIssue': 'Data de emissão do passaporte',
  'form.passportNumber.dateOfExpiry': 'Data de expiração do passaporte',
  'form.passportNumber.placeOfIssue': 'Local de emissão do passaporte',
  'nextOfKin.data': 'Contato de emergência / Parente próximo',
  'form.otherLinkType': 'Especifique o tipo de relação',
  'camera.problem.manual': 'Você está prestes a fazer o check-in/out desta solicitação de visto sem uma foto do cliente. Tem certeza de que deseja continuar?',
  'camera.problem.button': 'Problema com a câmera?',
  'global.noFilter': '--Sem filtro--',
  'zweentry': 'Entrada sem visto',
  'zweentry.title': 'Entrada sem visto',
  'free.charge': 'Sem custo',
  'camera.init.error': 'Ocorreu um erro ao inicializar a câmera. Deseja fazer o check-in/out desta solicitação sem uma foto do cliente?',
  'error.payment.noPaymentReference': 'Insira uma referência de pagamento, um método de pagamento e a moeda utilizada.',
  'paymentReference.ask': 'Referência do pagamento',
  'paymentReference.askExpired': 'Referência do pagamento para a taxa de permanência prolongada',
  'session.expired': 'Sua sessão expirou. Por favor, faça login novamente.',
  'phone.pattern': ' (ex.: +263771234567)',
  'global.receipt.id': 'ID da aplicação: {paymentId}',
  'ask.place.updatePermissions': 'Tem certeza de que deseja atualizar as permissões deste local?',
  'place.updatePermissions.success': 'As permissões do local foram atualizadas com sucesso.',
  'err.place.updatePermissions': 'Ocorreu um erro ao atualizar as permissões do local.',
  'global.urgent': 'Urgente',
  'form.usageAfter': 'Válido de',
  'form.usageUntil': 'Válido até',
  'form.localUsageUntil': 'Data máxima de estadia',
  'form.timeslot': 'Frequência de uso',
  'internalReference': 'Referência HQ',
  'payment_status.DYN.6.0': 'Aguardando revisão online 0/2',
  'payment_status.DYN.6.1': 'Aguardando revisão online 1/2',
  'payment_status.DYN.6.2': 'Aguardando revisão final online',
  'payment_status.DYN.8.0': 'Aguardando revisão de chegada',
  'payment_status.DYN.2.0': 'Check-in concluído',
  'payment_status.DYN.2.4': 'Pronto para check-out',
  'payment_status.DYN.2.5': 'Check-out concluído',
  'payment_status.DYN.2.6': 'Recusado no check-in',
  'payment_status.DYN.2.7': 'Recusado no check-out',
  'payment_status.DYN.2.8': 'Encerrado',
  'payment_status.extension.DYN.6.0': 'Aguardando revisão online 0/1',
  'payment_status.extension.DYN.6.2': 'Aguardando revisão final online',
  'payment_status.extension.DYN.7': 'Aguardando correção',
  'payment_status.extension.DYN.9': 'Extensão validada',
  'payment_status.extension.DYN.0': 'Pagamento pendente',
  'internalReference.create': 'Adicionar uma referência HQ',
  'internalReference.edit': 'Editar a referência HQ',
  'timeslot.set': 'Definir horário',
  'timeslot.setNew': 'Definir novo horário',
  'internalReference.ask.edit': 'Por favor, insira a nova referência HQ.',
  'internalReference.ask.create': 'Por favor, insira a referência HQ.',
  'internalReference.done.create': 'A referência HQ foi adicionada com sucesso.',
  'internalReference.done.edit': 'A referência HQ foi editada com sucesso.',
  'error.internalReference': 'Ocorreu um erro ao adicionar/editar a referência HQ.',
  'error.paymentUntil.expired': 'Este pedido está além do período de validade. Você pode prosseguir com o processo de checkout para o cliente; no entanto, esteja ciente de que uma taxa de USD 100 é necessária devido ao status expirado do pedido de visto. O pagamento deve ser feito imediatamente em uma das seguintes moedas:',
  'internalReference.desc': 'Adicione uma referência HQ a este pedido (por exemplo, 140_2024).',
  'titlePrint': 'Pedido de visto </br> <b>{paymentID}</b>',
  'titlePrint.extension': 'Pedido de extensão </br> <b>{paymentID}</b>',
  'globalStatus.valid': 'Válido',
  'PENDING.globalExplain': 'Esta solicitação está aguardando correção. Verifique as informações e corrija-as.',
  'PAID_NOT_CONFIRMED.globalExplain': 'Esta solicitação está aguardando confirmação pelos nossos serviços.',
  'PROPOSED.globalExplain': 'Esta solicitação está aguardando pagamento. Se ainda não efetuou o pagamento, pode fazê-lo agora.',
  'afterWithoutUntil': 'Você está autorizado a entrar de {dateAfter} até {deadlineDate}.',
  'afterWithoutUntilAndMillis': 'Você está autorizado a viajar a partir de {dateAfter}.',
  'afterAndUntil': 'Você está autorizado a viajar de {dateAfter} até {dateUntil}.',
  'photo.current': 'Foto atual',
  'photo.scanned': 'Foto escaneada do passaporte',
  'createdAt': 'Data de criação',
  'all.infos': 'Informações sobre este pedido',
  'afterRefused': 'Datas de viagem declaradas: {dateAfter}.',
  'DYN.paymentError.desc.success': '<p>Seu pedido foi registrado com sucesso. Caso alguma parte deste pedido exija aprovação de nossas equipes, você será notificado assim que este processo for concluído. Caso contrário, saiba que recebemos sua solicitação.</p><p><b>Obrigado por escolher nossos serviços.</b></p>',
  'sinceOneWeek': 'Observe que este documento está em estado de análise há mais de uma semana.',
  'client.extended.onlyAdminDecide': 'Este pedido de visto já foi analisado por um trabalhador com a mesma senioridade que você. Você não pode analisá-lo novamente.',
  'error.paymentUntil.before': 'A data é muito cedo. Este pedido será válido a partir de {dateAfter}.',
  'applicant.gender.FEMALE': 'Feminino',
  'applicant.gender.MALE': 'Masculino',
  'entry.consume': 'Chegadas',
  'exit.consume': 'Partidas',
  'scan.noConsumeMode': 'Como oficial de fronteira, você é responsável por gerenciar tanto as entradas quanto as saídas. Por favor, selecione a opção correspondente à sua tarefa atual: processar chegadas ou gerenciar partidas.',
  'scan.noVisaFound': "Nenhum registro no status 'Pronto para check-out' foi encontrado para esta pessoa. Deseja criar um registro pronto para check-out?",
  'zweexit': 'Saída sem visto',
  'err.scanPassport': 'Ocorreu um erro ao escanear o passaporte. Certifique-se de que está inserido corretamente e tente novamente. Se o problema persistir, reinicie o aplicativo ou entre em contato com o suporte.',
  'exit.register': 'Registrar uma saída',
  'entry.register': 'Registrar uma entrada',
  'exit.create': 'Criar uma saída sem visto',
  'exit.ask': 'Tem certeza de que deseja registrar uma saída sem visto para esta pessoa?',
  'border': 'Oficial na fronteira',
  'global.signout': 'Sair',
  'search.manually': 'Pesquisar pedido',
  'scan.applicationQr': 'Escanear QR do pedido',
  'err.client.extended.maxUsageCountReached': 'O número máximo de usos para este pedido foi atingido.',
  'form.firstName.scanned': 'Nome(s) escaneado(s)',
  'form.lastName.scanned': 'Sobrenome escaneado',
  'form.documentNumber.scanned': 'Número do passaporte escaneado',
  'form.gender.scanned': 'Gênero escaneado',
  'form.birthDate.scanned': 'Data de nascimento escaneada',
  'form.nationality': 'Nacionalidade',
  'form.nationality.scanned': 'Nacionalidade escaneada',
  'application.data': 'Dados do pedido',
  'no.passportPhoto': 'Sem foto',
  'overstay': 'Estadia excessiva',
  'method.payment': 'Método de pagamento',
  'review.desc': 'Aprovar/Recusar',
  'approval.usageUntil.DYN.': 'Alterar data de expiração (opcional)',
  'scanned.list': 'Lista de pedidos encontrados',
  'scanned.recommended': 'Recomendado',
  'scanned.entriesUsed': 'entradas utilizadas',
  'scanned.paid': 'Pago',
  'visa.blacklist': 'Este pedido de visto foi incluído na lista negra. A pessoa não tem permissão para entrar no país.',
  'scan.noEntryFound': "Nenhum registro no status 'Pronto para check-in' foi encontrado para esta pessoa. Deseja criar um registro pronto para check-in?",
  'global.syncing': 'Sincronizando...',
  'payment.consume.error.DYN.': 'Ocorreu um erro ao processar o pedido.',
  'tooltip.changeTimeslot': 'Alterar o horário',
  'tooltip.transit': 'Marque esta caixa de seleção para gerenciar o trânsito como um agente de fronteira.',
  'tooltip.Qr': 'Você pode escanear diretamente o código QR associado a um pedido para encontrar informações detalhadas sobre esse pedido.',
  'tooltip.arrivals': 'Marque esta caixa para gerenciar chegadas como oficial de fronteira.',
  'tooltip.departures': 'Marque esta caixa para gerenciar partidas como oficial de fronteira.',
  'tooltip.searchManually': 'Pesquise um pedido específico usando vários critérios.',
  'tooltip.signout': 'Sair do aplicativo.',
  'tooltip.my_account': 'Acesse as configurações da sua conta.',
  'tooltip.dashboard': 'Acesse o painel.',
  'tooltip.createRequests': 'Crie um novo pedido.',
  'tooltip.trips': 'Visualize o status dos seus pedidos e imprima o documento vinculado, se aprovado.',
  'tooltip.people': 'Gerencie as pessoas associadas à sua conta.',
  'tooltip.users': 'Gerencie os usuários do aplicativo.',
  'tooltip.places': 'Gerencie os locais do aplicativo.',
  'tooltip.role': 'Seu papel e nome dentro do aplicativo.',
  'tooltip.exitRegister': 'Registre manualmente uma saída sem visto para uma pessoa.',
  'tooltip.entryRegister': 'Registre manualmente uma entrada sem visto para uma pessoa.',
  'tooltip.support': 'Entre em contato com o suporte para obter ajuda com qualquer problema.',
  'tooltip.chooseLang': 'Altere o idioma do aplicativo. Atualmente, apenas o inglês está disponível.',
  'tooltip.changePassword': 'Altere sua senha.',
  'tooltip.internalReferenceNoFilter': 'Clique em uma referência interna, se disponível, para ser redirecionado à referência vinculada.',
  'tooltip.state': 'Filtre os pedidos com base em seu status.',
  'tooltip.tableBatchId': 'A referência do pedido associada ao pedido.',
  'tooltip.tableState': 'O status do pedido.',
  'tooltip.tableUsageAfter': 'A data de início do pedido.',
  'tooltip.tableUsageUntil': 'A data de expiração do pedido.',
  'tooltip.history': 'O histórico de pagamentos dos seus pedidos.',
  'tooltip.addPerson': 'Adicione uma nova pessoa vinculada à sua conta.',
  'tooltip.urgent': 'Significa que o pedido foi marcado como urgente e deve ser tratado o mais rápido possível.',
  'tooltip.operationId': 'O tipo de pedido.',
  'tooltip.purposeOfVisit': 'O propósito da visita para este pedido.',
  'tooltip.amount': 'O preço deste pedido.',
  'tooltip.paymentType': 'O tipo de pagamento para este pedido de visto.',
  'tooltip.paymentReference': 'A referência de pagamento para este pedido de visto.',
  'tooltip.review': 'Revise este pedido de visto como aprovado ou recusado e adicione um comentário.',
  'tooltip.revision': 'Peça ao cliente para corrigir o pedido de visto.',
  'tooltip.approve': "Aprove este pedido de visto como decisão final. Você também pode adicionar um comentário. Se o termo 'lista negra' estiver presente, a pessoa será colocada na lista negra.",
  'tooltip.refuse': 'Recuse este pedido de visto como decisão final. Você também pode adicionar um comentário.',
  'tooltip.qrSee': 'Veja o código QR deste pedido e imprima o documento vinculado a ele.',
  'tooltip.internalEdit': 'Edite a referência interna deste pedido de visto.',
  'tooltip.internalAdd': 'Adicione uma referência interna a este pedido.',
  'tooltip.printApplication': 'Imprima o pedido com todas as informações.',
  'tooltip.allReviews': 'Todas as revisões deste pedido de visto, com a data e o usuário que realizou a revisão.',
  'tooltip.version': 'A versão atual do pedido.',
  'tooltip.consumeProfile.IN': 'A foto capturada no ponto de entrada.',
  'tooltip.consumeNoProfile.IN': 'Nenhuma foto capturada no ponto de entrada.',
  'tooltip.consumeTime.IN': 'A data e hora do ponto de entrada.',
  'tooltip.consumePlace.IN': 'O local do ponto de entrada.',
  'tooltip.consumeProfile.OUT': 'A foto capturada no ponto de saída.',
  'tooltip.consumeNoProfile.OUT': 'Nenhuma foto capturada no ponto de saída.',
  'tooltip.consumeTime.OUT': 'A data e hora do ponto de saída.',
  'tooltip.consumePlace.OUT': 'O local do ponto de saída.',
  'tooltip.passportComparison': 'Informações escaneadas do passaporte. Permite comparar as informações com os dados reais do pedido.',
  'tooltip.classicComparison': 'Informações reais do pedido. Permite comparar os dados com as informações escaneadas do passaporte.',
  'tooltip.trackingApplicationReference': 'Referência do pedido dessas aplicações.',
  'tooltip.allTrackingInfo': 'Todas as informações sobre este pedido.',
  'tooltip.trackingPrint': 'Imprima o documento vinculado a este pedido.',
  'tooltip.docFirstName': 'Insira o primeiro nome da pessoa como consta no passaporte.',
  'tooltip.docLastName': 'Insira o sobrenome da pessoa como consta no passaporte.',
  'tooltip.docPassportNumber': 'Insira o número do passaporte da pessoa.',
  'tooltip.docLinkType': 'Selecione o tipo de relação que você tem com a pessoa.',
  'tooltip.docLinkTypeOther': 'Especifique o tipo de relação que você tem com a pessoa.',
  'tooltip.applicationReferenceRequest': 'A referência do pedido da solicitação. É única para cada solicitação e é gerada automaticamente.',
  'tooltip.portEntryRequest': 'O porto de entrada da solicitação. É o local onde a pessoa entrará no país.',
  'tooltip.otherName': 'Insira o outro nome do solicitante como consta no passaporte.',
  'tooltip.spouseCheckbox': 'Marque esta caixa se o solicitante tiver um cônjuge e preencha as informações abaixo.',
  'tooltip.hostName': 'O nome da pessoa/organização que hospedará o solicitante.',
  'tooltip.scanPassport': 'Escaneie o passaporte do solicitante para encontrar pedidos vinculados a este passaporte. Se nenhum pedido for encontrado, você pode criar um novo.',
  'tooltip.passportScanned': 'As informações escaneadas do passaporte.',
  'tooltip.scannedCard': 'Pedidos semelhantes encontrados com as informações escaneadas.',
  'scan.error': 'Ocorreu um erro durante o escaneamento do documento.',
  'tooltip.webcamProblems': 'Se a câmera não funcionar corretamente, você ainda pode fazer o check-in ou check-out do pedido sem uma foto.',
  'tooltip.checkOut': 'Faça o check-out da pessoa do país.',
  'tooltip.checkIn': 'Faça o check-in da pessoa no país.',
  'tooltip.consumeRefuse': 'Recuse a entrada ou saída da pessoa.',
  'tooltip.finalRefuse': 'A decisão final do pedido. A pessoa não poderá entrar no país.',
  'tooltip.finalApprove': 'A decisão final do pedido. A pessoa poderá entrar ou sair do país.',
  'tooltip.finalPending': 'A decisão final do pedido. A pessoa não poderá entrar no país até que o pedido seja corrigido e aprovado.',
  'tooltip.finalRefuseBlacklist': 'A decisão final do pedido. A pessoa não poderá entrar no país e será colocada na lista negra.',
  'err.ResidencePermitNumber.pattern': 'O número do permissão de residência deve conter apenas letras maiúsculas e dígitos',
  'photo.entryCountry.IN': 'Foto no check-in',
  'dashboard.noPreviousApplication': 'Nenhuma aplicação anterior encontrada.',
  'photo.entryCountry.OUT': 'Foto no check-out',
  'supervision.login.error': 'Falha na verificação do supervisor.',
  'err.noPassiveAuthenticationCSCA': 'O documento é válido, mas não pôde ser verificado com a autoridade emissora.',
  'err.passport.expired': 'A validade do passaporte expirou.',
  'externalIndexedData': 'Múltiplos passaportes encontrados',
  'client.extended.chargedBack': 'Este pedido de visto foi reembolsado. O indivíduo ainda pode prosseguir com o check-out, mas é necessário pagar a taxa de entrada em dinheiro.',
  'ask.chargedBack.confirm': 'Você confirma que a pessoa pagou a taxa de entrada? Se confirmar, insira a referência do pagamento e a moeda usada.',
  'error.payment.noReferenceChargedBack': 'Por favor, insira uma referência de pagamento e a moeda usada.',
  'client.extended.entryChargedBack': 'Este pedido de visto foi reembolsado. O indivíduo não pode prosseguir com o check-in e deve criar uma nova entrada.',
  'tooltip.syncing': 'O número de processos de pedidos atualmente em sincronização.',
  'adChoice': 'Conexão com o diretório ativo',
  'external.down': 'Um serviço do qual nosso aplicativo depende não está funcionando no momento. Tente novamente mais tarde.',
  'global.connection.server': 'Serviço indisponível. Pedimos desculpas pelo transtorno, tente novamente mais tarde.',
  'global.connection.problem': 'Erro ao carregar sua solicitação. Verifique se você não está usando VPNs, firewalls, se sua conexão com a internet é estável e tente novamente.',
  'err.passport.issuedSoon': 'O passaporte foi emitido recentemente (menos de um mês atrás).',
  'global.reload': 'Recarregar',
  'error.passportScan': 'CertBytes(b64): <pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': "O hash do certificado do passaporte não foi encontrado na lista mestre da ICAO, resultando no erro 'err.noPassiveAuthenticationCSCA'.",
  'glpi.err.unverifiedDoc': "Falha ao recuperar os bytes do certificado para autenticação passiva; isso resulta no erro 'err.unverifiedDoc'.",
  'glpi.err.noPassiveAuthentication': "Falha ao realizar a autenticação passiva; isso resulta no erro 'err.noPassiveAuthentication'.",
  'glpi.err.noConnect': "Falha ao estabelecer conexão com o chip do passaporte, resultando no erro 'err.noConnect'.",
  'glpi.err.noBAC': "A BAC falhou ao ser estabelecida com as informações fornecidas do MRZ, acionando o erro 'err.noBAC'.",
  'glpi.err.alteredDoc': "Os hashes do Grupo de Dados (DGS) estão incorretos para uma ou mais entradas, levando ao erro 'err.alteredDoc'.",
  'glpi.err.revokedDocSigner': "O número de série do certificado do signatário do documento está na Lista de Revogação de Certificados (CRL), resultando no erro 'err.revokedDocSigner'.",
  'watchlistCollapse': '<p>Listas de vigilância encontradas - <span class="watchlistCategories">{categories}</span></p>',
  'match.type': 'Tipo de correspondência',
  'match.hair': 'Cabelo',
  'match.eyes': 'Olhos',
  'match.height': 'Altura',
  'match.weight': 'Peso',
  'match.race': 'Raça',
  'global.category': 'Categoria',
  'watchlist.alertLevel': 'Nível de alerta da lista de vigilância',
  'watchlist.match': 'Correspondência {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'Nationalities': 'Nacionalidade {index}',
  'global.score': 'Pontuação',
  'watchlist.name': 'Nome da lista de vigilância',
  'alias': 'Apelido {index}',
  'document.number': 'Número do documento {index}',
  'document.issuer': 'Emissor do documento {index}',
  'document.type': 'Tipo de documento {index}',
  'dateOfBirth': 'Data de nascimento {index}',
  'watchlist.marks': 'Marcas',
  'watchlist.image.link': 'Link para a imagem encontrada {index}',
  'image.match': 'Imagem correspondente {index}',
  'tooltip.watchlist': 'As informações da lista de vigilância encontradas para esta pessoa.',
  'watchList.category': 'Categoria da lista de vigilância',
  'watchlist.level': 'Nível de alerta.',
  'scan.fingerprint.desc': 'Quando estiver pronto, clique no botão abaixo para iniciar o processo de coleta das impressões digitais da pessoa. A pessoa deve colocar o dedo indicador no scanner quando a luz vermelha do dispositivo de impressões digitais acender, conforme indicado pelo oficial.',
  'scan.fingerprint.noResponse': 'Nenhuma resposta do scanner de impressões digitais. A pessoa colocou o dedo no scanner? O dispositivo está corretamente conectado?',
  'scan.fingerprint': 'Impressão digital',
  'fingerprint.scan.start': 'Escanear impressão digital',
  'scan.fingerprint.success': 'As impressões digitais foram escaneadas com sucesso. A qualidade da impressão digital escaneada é {quality}/100. Você pode repetir o processo se a qualidade não for suficiente.',
  'fingerprint.notAvailable': 'Parece que o scanner de impressões digitais não está disponível ou os drivers não estão instalados. Você ainda pode prosseguir com o check-in sem as impressões digitais.',
  'skip': 'Pular',
  'global.checkOut.fingerprint': 'Check-out com impressão digital',
  'global.checkIn.fingerprint': 'Check-in com impressão digital',
  'tooltip.checkOut.fingerprint': 'Check-out da pessoa do país usando a impressão digital.',
  'tooltip.checkIn.fingerprint': 'Check-in da pessoa no país usando a impressão digital.',
  'paymentError.title': 'Problema com seu pedido',
  'DYN.paymentError.desc.fail': 'Infelizmente, o pagamento falhou. Por favor, tente novamente.',
  'DYN.paymentError.desc.error': 'Infelizmente, o processamento do pagamento retornou um erro. Por favor, entre em contato conosco.',
  'DYN.paymentError.desc.later': 'Infelizmente, o processamento do pagamento foi temporariamente recusado. Por favor, tente novamente.',
  'tooltip.applicationId': 'O ID do pedido.',
  'client.extended.missingResource': 'O recurso solicitado não está disponível no momento. Por favor, tente novamente mais tarde.',
  'skip.valid': 'Pular automaticamente as etapas revisadas.',
  'extension.data': 'Dados da extensão.',
  'attestantAddress': 'Endereço do declarante.',
  'attestantEmail': 'Email do declarante.',
  'attestantID': 'ID do declarante.',
  'attestantName': 'Nome do declarante.',
  'attestantPhone': 'Telefone do declarante.',
  'attestantRelation': 'Relação com o declarante.',
  'daysRequested': 'Número de dias solicitados.',
  'tooltip.visaApplicationReference': 'Vá para o pedido de visto vinculado a esta solicitação de extensão.',
  'extend.visaReference': 'Pedido vinculado a esta solicitação de extensão.',
  'data.copyOfEntry': 'Cópia da entrada.',
  'data.departureTicket': 'Bilhete de saída.',
  'data.attestantDocument': 'Documento do declarante.',
  'data.affidavitCustody': 'Declaração de custódia.',
  'reasonForExtention': 'Motivo da extensão.',
  'final.ZWEVISAEXTAB': 'Esta solicitação de extensão precisa ser aprovada pelo oficial.',
  'zwevisaExtValid': 'Extensão validada',
  'zwevisaExtValid.desc': 'Esta solicitação de extensão foi validada pelo oficial.',
  'zwevisaExtC.review.state': 'Aguardando revisão',
  'zwevisaExtC.review.desc': 'Esta solicitação de extensão está aguardando revisão.',
  'zwevisaExtC.finalReview.desc': 'Esta solicitação de extensão foi revisada e está aguardando a revisão final.',
  'zwevisaExtC.finalReview.state': 'Aguardando revisão final',
  'onlyFinalReview': 'Este pedido está aguardando revisão final.',
  'tooltip.tableLocalUsageUntil': 'A data de expiração do pedido refere-se à data máxima de permanência.',
  'error.bad.localUsageUntil': 'A data máxima de permanência deve ser inferior à data de expiração atual e após o dia de hoje.',
  'none': 'Nenhum',
  'change.password.ad': 'Tendo uma conta no diretório ativo, você não pode alterar sua senha aqui. Para mais informações, entre em contato com o suporte.',
  'noticePrint.title': 'Informações do aviso ao visitante impressas para o cliente',
  'reportingPost': 'Posto de relatório',
  'noticePrint.matTooltip': 'Informações do aviso ao visitante impressas para o cliente durante o processo de check-in',
  'notice.confirm': 'Você confirma as informações no aviso?',
  'global.refusePrint': 'Imprimir e enviar',
  'global.nextPrint': 'Imprimir e continuar',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'O período inicial deve ser antes do período final.',
  'payment.reject_reason': 'Motivo da rejeição',
  'err.fileSize': 'O tamanho do arquivo é muito grande. O tamanho máximo é: {size}',
  'document.zafembpass': 'Passaporte da embaixada ZAF',
  'preenroll': 'Pré-inscrição',
  'screen': 'Triagem',
  'pass': 'Passaporte',
  'document.pass': 'Passaporte',
  'document.screen': 'Triagem',
  'payment.ask.print': 'O recibo foi impresso?',
  'global.no.retry': 'Não (tentar novamente)',
  'print.receipt': 'Imprimir o recibo',
  'tooltip.printReceipt': 'Imprimir o(s) recibo(s) do pedido',
  'ask.printReceipt': 'Você deseja imprimir o recibo datado de <b>{date}</b>?',
  'error.printReceipt': 'Ocorreu um erro ao imprimir o recibo. Por favor, tente novamente.',
  'ask.selectReceipt': 'Por favor, selecione o recibo que deseja imprimir.',
  'operation.OUT': 'Check-out',
  'operation.IN': 'Check-in',
  'operation.PAYMENT_FINALIZED': 'Pagamento finalizado',
  'operation.PAYMENT_CREATED': 'Pagamento criado',
  'operation.PAYMENT_USED_FORCE': 'Pagamento utilizado (forçado)',
  'noChoice.selectedReceipt': 'Por favor, selecione um recibo para imprimir.',
  'select.receipt': 'Selecionar o recibo',
  'receiptFor.alt': 'Recibo para',
  'paymentType': 'Tipo de pagamento',
  'totalAmount.alt': 'Montante total',
  'totalAmount': 'Montante total',
  'date': 'Data',
  'client': 'Cliente',
  'desc': 'Descrição',
  'details': 'Detalhes',
  'client.extended.minUsageNotMet': 'A validade deve ser pelo menos 1 dia após a data de início.',
  'payment.assigned.warning': 'Este pedido está atualmente em uso ativo por outro oficial (Oficial: {officerId}) há menos de 24 horas. Deseja abrir este pedido mesmo assim?',
  'lock': 'Bloquear',
  'tooltip.tableLockTitle': 'Uso ativo por oficial(is)',
  'client.extended.uuidNotPaid': 'O pagamento ainda não foi validado. Por favor, valide o pagamento antes de prosseguir.',
  'form.operationComments': 'Justifique a operação.',
  'borderPass.emit': 'Passe de fronteira emitido',
  'tooltip.borderPass': 'O passe de fronteira é um documento que permite a uma pessoa cruzar a fronteira. É usado quando a pessoa não tem um passaporte.',
  'zweexit.title': 'Saída sem visto',
  'borderPass.title': 'Passe de fronteira',
  'print.borderPass': 'Imprimir o passe de fronteira',
  'print.borderPass.ask': 'O passe de fronteira foi impresso?',
  'err.issueDate.afterExpiryDate': 'A data de emissão deve ser antes da data de validade.',
  'err.BirthDay.afterExpiryDate': 'A data de nascimento deve ser antes da data de validade.',
  'err.BirthDay.afterIssueDate': 'A data de nascimento deve ser antes da data de emissão.',
  'apiPnrCollapse': 'PNR encontrado',
  'apipnrResponse.match': 'Correspondência {numberMatch}',
  'match.name': 'Nome',
  'match.score.name': 'Pontuação do nome',
  'match.flightCarrier': 'Companhia aérea',
  'match.flightNumber': 'Número do voo',
  'match.documentType': 'Tipo de documento',
  'match.documentNumber': 'Número do documento',
  'match.documentIssuer': 'Emissor do documento',
  'match.timeType': 'Tipo de evento',
  'match.timeDate': 'Data do evento',
  'match.timeScope': 'Escopo do evento',
  'match.nationality': 'Nacionalidade',
  'match.gender': 'Gênero',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'UUID do viajante',
  'tooltip.apiPnr': 'As informações do PNR encontradas para esta pessoa.',
  'match.documentIssued': 'Data de emissão do documento',
  'match.placeIssued': 'Local de emissão do documento',
  'match.documentExpiration': 'Data de expiração do documento',
  'match.documentScore': 'Pontuação do documento',
  'match.timeScore': 'Pontuação do evento',
  'match.flightOriginDomestic': 'Origem doméstica do voo',
  'match.flightOriginIcao': 'ICAO da origem do voo',
  'match.flightOriginLat': 'Latitude da origem do voo',
  'match.flightOriginLng': 'Longitude da origem do voo',
  'match.flightOriginIata': 'IATA da origem do voo',
  'match.flightOriginCity': 'Cidade da origem do voo',
  'match.flightOriginState': 'Estado da origem do voo',
  'match.flightOriginCountry': 'País da origem do voo',
  'match.flightOriginContinent': 'Continente da origem do voo',
  'match.flightOriginName': 'Nome da origem do voo',
  'match.flightOriginTimezone': 'Fuso horário da origem do voo',
  'match.flightDestinationDomestic': 'Destino doméstico do voo',
  'match.flightDestinationIcao': 'ICAO do destino do voo',
  'match.flightDestinationLat': 'Latitude do destino do voo',
  'match.flightDestinationLng': 'Longitude do destino do voo',
  'match.flightDestinationIata': 'IATA do destino do voo',
  'match.flightDestinationCity': 'Cidade do destino do voo',
  'match.flightDestinationState': 'Estado do destino do voo',
  'match.flightDestinationCountry': 'País do destino do voo',
  'match.flightDestinationContinent': 'Continente do destino do voo',
  'match.flightDestinationName': 'Nome do destino do voo',
  'match.flightDestinationTimezone': 'Fuso horário do destino do voo',
  'match.localDepartureDate': 'Data de partida local',
  'match.localDepartureTime': 'Hora de partida local',
  'match.localDepartureTotalMinutes': 'Total de minutos da partida local',
  'match.localDepartureDay': 'Dia de partida local',
  'match.localDepartureZone': 'Zona de partida local',
  'match.airportDepartureDate': 'Data de partida no aeroporto',
  'match.airportDepartureTime': 'Hora de partida no aeroporto',
  'match.airportDepartureTotalMinutes': 'Total de minutos da partida no aeroporto',
  'match.airportDepartureDay': 'Dia de partida no aeroporto',
  'match.airportDepartureZone': 'Zona de partida no aeroporto',
  'match.utcDepartureDate': 'Data de partida UTC',
  'match.utcDepartureTime': 'Hora de partida UTC',
  'match.utcDepartureTotalMinutes': 'Total de minutos da partida UTC',
  'match.utcDepartureDay': 'Dia de partida UTC',
  'match.utcDepartureZone': 'Zona de partida UTC',
  'match.originalDeparture': 'Partida original',
  'match.flightDepartureUtcstr': 'Partida UTC do voo',
  'match.localArrivalDate': 'Data de chegada local',
  'match.localArrivalTime': 'Hora de chegada local',
  'match.localArrivalTotalMinutes': 'Total de minutos da chegada local',
  'match.localArrivalDay': 'Dia de chegada local',
  'match.localArrivalZone': 'Zona de chegada local',
  'match.airportArrivalDate': 'Data de chegada no aeroporto',
  'match.airportArrivalTime': 'Hora de chegada no aeroporto',
  'match.airportArrivalTotalMinutes': 'Total de minutos da chegada no aeroporto',
  'match.airportArrivalDay': 'Dia de chegada no aeroporto',
  'match.airportArrivalZone': 'Zona de chegada no aeroporto',
  'match.utcArrivalDate': 'Data de chegada UTC',
  'match.utcArrivalTime': 'Hora de chegada UTC',
  'match.utcArrivalTotalMinutes': 'Total de minutos da chegada UTC',
  'match.utcArrivalDay': 'Dia de chegada UTC',
  'match.utcArrivalZone': 'Zona de chegada UTC',
  'match.originalArrival': 'Chegada original',
  'match.flightArrivalUtcstr': 'Chegada UTC do voo',
  'match.flightBound': 'Destino do voo',
  'ask.notice': 'Imprimir um aviso ao visitante ou uma notificação provisória de restrição.',
  'tooltip.checkIn.notice': 'Faça o check-in da pessoa no país e imprima o aviso ao visitante ou uma notificação provisória de restrição.',
  'global.checkIn.notice': 'Check-in com aviso',
  'event.downgrade': 'Este pedido foi rebaixado de <b>{previousPayment}</b> para <b>{newPayment}</b> em {date} pelo usuário <b>{userId}</b>.',
  'form.numberPeople': 'Número de pessoas viajando com o solicitante',
  'feedbackForm': 'Formulário de feedback',
  'form.totalSpend': 'Gasto total durante a estadia',
  'countryPermanentResidence': 'País de residência permanente',
  'form.feedbackComments': 'Comentários adicionais',
  'feedback.submit': 'Enviar feedback',
  'feedback.submitted': 'O feedback foi enviado com sucesso.',
  'residencePermit.warning': 'Número do título de residência <b>{permitNumber}</b> não encontrado na base de dados.<br><br>Por favor, verifique manualmente este número no título físico do viajante antes de aprovar a entrada.',
  'statusLabel.toConfirm': '(a confirmar)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'Cidade de nascimento',
  'form.eyeColor': 'Cor dos olhos',
  'form.hairColor': 'Cor do cabelo',
  'form.height': 'Altura',
  'form.occupation': 'Ocupação',
  'form.fatherFirstName': 'Primeiro nome do pai',
  'form.fatherLastName': 'Sobrenome do pai',
  'form.motherFirstName': 'Primeiro nome da mãe',
  'form.motherLastName': 'Sobrenome da mãe',
  'form.physical.description': 'Descrição física',
  'documents.no.documents': 'Nenhum documento foi encontrado para esta aplicação',
  'OtherPurpose': 'Outra razão',
  'form.seniority.ownPlace': 'Somente espaço próprio',
  'form.seniority.allPlaces': 'Todos os lugares',
  'nav.searchFromDocument': 'Pesquisar a partir do documento',
  'document.Preview': 'Visualizar documento',
  'traveller.history.title': 'Histórico do viajante',
  'traveller.history.loading': 'Carregando histórico…',
  'traveller.history.entry_exit': 'Entrada / Saída',
  'traveller.history.compliance': 'Conformidade',
  'traveller.history.view_more': 'Ver mais',
  'traveller.history.collapse': 'Recolher',
  'traveller.history.no_records': 'Nenhum registro encontrado',
  'traveller.history.records': 'registros',
  'traveller.history.user': 'Utilizador',
  'traveller.history.reason': 'Motivo',
  'traveller.history.additional_info': 'Informações adicionais',
  'traveller.history.event.ENTERED_COUNTRY': 'Entrada no país',
  'traveller.history.event.EXITED_COUNTRY': 'Saída do país',
  'traveller.history.event.DEPORTATION_CREATED': 'Deportação criada',
  'traveller.history.event.DEPORTATION_EDITED': 'Deportação editada',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'Deportação aprovada pelo supervisor',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'Deportação aprovada pelo Dir. Ops',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'Deportação concluída',
  'traveller.history.event.DEPORTATION_DECLINED': 'Deportação recusada',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'Adicionado à lista de vigilância',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'Removido da lista de vigilância',
  'traveller.history.event.PROSECUTION_CREATED': 'Processo judicial criado',
  'traveller.history.event.ADDED_BIOMETRIC': 'Biometria adicionada',
  'traveller.history.event.INTERVIEW_CREATED': 'Entrevista criada',
  'traveller.history.event.INTERVIEW_EDITED': 'Entrevista editada',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'Registro de refugiado criado',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'Registro de refugiado editado',
  'traveller.history.visa': 'Visto',
  'traveller.history.event.VALIDATED': 'Validado',
  'traveller.history.event.REFUSED': 'Recusado',
  'traveller.history.permits': 'Autorizações',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'Autorização de residência ordinária',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'Autorização de residência de cônjuge',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'Autorização de residência de investidor',
  'traveller.history.permit.STUDENTS_PERMIT': 'Autorização de estudante',
  'traveller.history.permit.SCHOLARS_PERMIT': 'Autorização escolar',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'Autorização de trabalho temporário',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'Autorização de trabalho',
  'traveller.history.permit.RESUMPTION': 'Retomada',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'Dupla cidadania',
  'traveller.history.permit.REINSTATEMENT': 'Reintegração',
  'traveller.history.permit.applicationType': 'Tipo de pedido',
  'traveller.history.permit.appType.INITIAL': 'Inicial',
  'traveller.history.permit.appType.EXTENSION': 'Extensão',
  'traveller.history.permit.appType.PERMANENT': 'Permanente',
  'traveller.history.permit.status.REQUESTED': 'Solicitado',
  'traveller.history.permit.status.APPROVED': 'Aprovado',
  'traveller.history.permit.status.REJECTED': 'Rejeitado',
  'traveller.history.permit.issueDate': 'Data de emissão',
  'traveller.history.permit.expiryDate': 'Data de validade',
  'showcase.heroTitle': 'Rápido, seguro & <em>digital</em><br/>experiência eVisa.',
  'showcase.heroSubtitle': 'Solicite, verifique e viaje em minutos. {name} combina identidade biométrica com um motor de decisão governamental — para que a sua aprovação chegue antes de você.',
  'showcase.heroSubtitle.evisa': 'Solicite, verifique e viaje em minutos. {name} combina identidade biométrica com um motor de decisão governamental — para que a sua aprovação chegue antes de você.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'Preencha o seu pedido de passaporte, bilhete de identidade ou autorização de residência online. {name} processa e acompanha cada pedido em tempo real, da submissão à entrega.',
  'showcase.heroSubtitle.passport_idCard': 'Solicite passaporte ou bilhete de identidade online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroSubtitle.passport': 'Solicite o seu passaporte online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroSubtitle.idCard': 'Solicite o seu bilhete de identidade online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroSubtitle.residencePermit': 'Solicite a sua autorização de residência online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroSubtitle.passport_residencePermit': 'Solicite passaporte ou autorização de residência online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroSubtitle.idCard_residencePermit': 'Solicite bilhete de identidade ou autorização de residência online. {name} processa e acompanha cada pedido em tempo real.',
  'showcase.heroCta1': 'Solicitar eVisa',
  'showcase.heroCta2': 'Acompanhar pedido',
  'showcase.flowTitleMain': 'Quatro etapas.<br/><em>Zero filas.</em>',
  'showcase.flowTitleSub': 'Um pedido que viaja consigo.',
  'showcase.flowSubtitle': '{name} orquestra as quatro etapas do seu pedido num único movimento fluido, o sistema trata da burocracia enquanto você faz as malas.',
  'showcase.ctaTitle': 'Comece a sua viagem<br/><em>digitalmente.</em>',
  'showcase.ctaSubtitle': 'Um pedido. Um eVisa no seu bolso e uma decisão que chega antes de você.',
  'showcase.step1.label': 'Criar pedido',
  'showcase.step1.paneTitle': 'Preencha os seus dados',
  'showcase.step1.paneDesc': 'Destino, datas de viagem, motivo da visita e ponto de entrada…',
  'showcase.step2.label': 'Enviar documentos',
  'showcase.step2.paneTitle': 'Envie o seu passaporte',
  'showcase.step2.paneDesc': 'Digitalização do passaporte, leitura MRZ, extração instantânea de campos…',
  'showcase.step3.label': 'Verificação biométrica',
  'showcase.step3.paneTitle': 'Detecção de vivacidade & correspondência facial',
  'showcase.step3.paneDesc': 'Verificação de vivacidade, correspondência facial e triagem de sanções…',
  'showcase.step4.label': 'Aprovação instantânea',
  'showcase.step4.paneTitle': 'Aprovado & pronto para a fronteira',
  'showcase.step4.paneDesc': 'O seu eVisa está assinado, selado e sincronizado com a sua carteira…',
  'showcase.stat1.value': 'Encriptado',
  'showcase.stat1.label': 'ponta a ponta',
  'showcase.stat2.value': 'Certificado',
  'showcase.stat2.label': 'plataforma segura',
  'showcase.portalType': 'Portal eVisa',
  'showcase.tl.step1': 'Identidade',
  'showcase.tl.step3': 'Decisão',
  'showcase.tl.step4': 'Viagem',
  'showcase.tl.step2': 'Documentos',
  'showcase.evisa.ministry': 'MINISTÉRIO DOS NEGÓCIOS ESTRANGEIROS',
  'showcase.marquee.issuedBy': 'Emitido por autoridades soberanas',
  'showcase.marquee.biometric': 'Biométrico',
  'showcase.marquee.secured': 'Seguro',
  'showcase.marquee.borderReady': 'Pronto na fronteira em minutos',
  'showcase.marquee.encrypted': 'Cifrado de ponta a ponta',
  'showcase.marquee.eSeal': 'Selo eletrónico qualificado',
  'showcase.marquee.realtime': 'Rastreamento em tempo real',
  'showcase.annot.mrz': 'MRZ verificado',
  'showcase.annot.biometric': 'Biométrico',
  'showcase.annot.issued': 'Emitido',
  'showcase.annot.secured': 'Seguro',
  'showcase.howItWorks': 'Como funciona',
  'showcase.signIn': 'Entrar na minha conta',
  'showcase.scroll': 'Rolar',
  'showcase.permit.badge': 'RESIDENTE',
  'showcase.permit.title': 'AUTORIZAÇÃO',
  'showcase.permit.name': 'Autorização de residência',
  'finger.thumb': 'Polegar',
  'finger.index': 'Indicador',
  'finger.middle': 'Médio',
  'finger.ring': 'Anelar',
  'finger.little': 'Mínimo',
  'finger.missing': 'Faltando',
  'hand.left': 'Mão esquerda',
  'hand.right': 'Mão direita',
  'fingerprints': 'Impressões digitais',
  'finger.thumbs': 'Polegar',
  'fingers.missing': 'Dedos faltando',
  'signature': 'Assinatura',
  'print.withdrawal.date': 'Data de retirada',
  'trips.helper': 'Clique para visualizar/baixar o código QR'
};
